/* ============================================================
   Pocket Tripod PROv2 · Page D theme JS
   Self-contained, theme-independent. Reads its config from the
   #pt-data JSON blob rendered by the Buy section (live prices,
   variants, tier percentages, texts). No prices are hardcoded.
   v3: the phone matcher is its own section (pt-matcher.liquid)
   with its own #pt-matcher-data blob, so it works on pages with
   or without a buy box. When a buy box is present it registers
   window.__ptApplyMatch and a match sets the fit there.
   ============================================================ */
(function () {
  "use strict";
  if (window.__ptPageLoaded) return;   /* sections may each include the script tag */
  window.__ptPageLoaded = true;
  document.documentElement.classList.add("pt-js");

  var $ = function (id) { return document.getElementById(id); };

  /* security: escape EVERYTHING dynamic that reaches innerHTML.
     Data sources are staff-controlled settings plus the remotely
     fetched fit database; escaping makes a compromised or malformed
     source a cosmetic problem instead of script injection. */
  function esc(v) {
    return String(v == null ? "" : v).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function safeHex(v) { return /^#[0-9a-fA-F]{3,8}$/.test(String(v || "")) ? v : "#999"; }
  function safeUrl(v) { v = String(v || ""); return (/^https:\/\//.test(v) || v.charAt(0) === "/") ? v : ""; }

  var D = null;
  var dataEl = $("pt-data");
  if (dataEl) {
    try { D = JSON.parse(dataEl.textContent); }
    catch (e) { if (window.console) console.warn("[pt] data blob unreadable", e); }
  }
  /* matcher section config (independent of the buy box) */
  var MC = {};
  var mcEl = $("pt-matcher-data");
  if (mcEl) {
    try { MC = JSON.parse(mcEl.textContent) || {}; }
    catch (e) { if (window.console) console.warn("[pt] matcher data blob unreadable", e); }
  }
  var FALLBACK_MODELS = [];
  var fmEl = $("pt-fallback-models");
  if (fmEl) {
    /* the blob is | json-encoded (a JSON string wrapping the merchant's JSON,
       so a "</script" in the textarea can never terminate the element);
       parse twice. Plain-array blobs from older section renders still work. */
    try {
      var fm = JSON.parse(fmEl.textContent);
      if (typeof fm === "string") fm = JSON.parse(fm);
      if (Array.isArray(fm)) FALLBACK_MODELS = fm;
    }
    catch (e) { if (window.console) console.warn("[pt] fallback models JSON invalid; matcher will rely on the database URL"); }
  }

  /* ---------- shared widgets (work even without the buy section) ---------- */

  // accordions / FAQ
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".pt-acc > button");
    if (!btn) return;
    var p = btn.parentElement;
    // one open at a time within the same group: close the siblings before toggling this one
    var group = p.parentElement;
    if (group) {
      group.querySelectorAll(":scope > .pt-acc.pt-open").forEach(function (o) {
        if (o === p) return;
        o.classList.remove("pt-open");
        var ob = o.querySelector(":scope > button"); if (ob) { ob.setAttribute("aria-expanded", "false"); var om = ob.querySelector("span[aria-hidden]") || ob.querySelector("span"); if (om) om.textContent = "+"; }
      });
    }
    var open = p.classList.toggle("pt-open");
    btn.setAttribute("aria-expanded", open ? "true" : "false");
    var mark = btn.querySelector("span[aria-hidden]") || btn.querySelector("span");
    if (mark) mark.textContent = open ? "−" : "+";
  });

  /* comparison rail: carousel dots standing in for the scrollbar. One dot per
     screenful, the filled one tracking how far along the rail is, and the whole
     row hidden when nothing overflows. */
  /* The feature column and the value columns are separate grids so the first can
     sit outside the scroller (see pt-compare.liquid). Separate grids size their
     rows independently, so each row is measured on both sides and both are pinned
     to the taller of the two. */
  function syncCmpRows(split) {
    var labels = split.querySelector(".pt-cmp2-labels");
    var grid = split.querySelector(".pt-cmp2");
    if (!labels || !grid) return;
    var labCells = [].slice.call(labels.children);          /* corner, then one per row */
    var rows = labCells.length;
    labels.style.gridTemplateRows = "";
    grid.style.gridTemplateRows = "";
    var heights = [];
    for (var r = 0; r < rows; r++) {
      var h = labCells[r].getBoundingClientRect().height;
      var mates = grid.querySelectorAll('[style*="grid-row:' + (r + 1) + '"]');
      [].forEach.call(mates, function (m) {
        if (m.classList.contains("pt-cmp2-panel")) return;   /* spans every row */
        h = Math.max(h, m.getBoundingClientRect().height);
      });
      heights.push(Math.ceil(h) + "px");
    }
    var tracks = heights.join(" ");
    labels.style.gridTemplateRows = tracks;
    grid.style.gridTemplateRows = tracks;
  }

  function initCmpDots(root) {
    (root || document).querySelectorAll(".pt-cmp2-scroll").forEach(function (rail) {
      if (rail.__ptDots) return;
      rail.__ptDots = true;
      var split = rail.closest(".pt-cmp2-split");
      var dots = split && split.parentElement.querySelector(".pt-cmp2-dots");
      var hint = split && split.parentElement.querySelector(".pt-cmp2-hint");
      if (split) syncCmpRows(split);
      if (!dots) return;
      var mark = function () {
        /* the feature column only casts a shadow once something has actually
           slid under it — before that it is just part of the table */
        if (split) split.classList.toggle("pt-stuck", rail.scrollLeft > 2);
        /* the swipe hint has done its job once the visitor actually swipes;
           fade it (opacity only — no layout shift) and never bring it back */
        if (hint && !hint.__ptDone && rail.scrollLeft > 40) {
          hint.__ptDone = true; hint.classList.add("pt-hint-off");
        }
        var max = rail.scrollWidth - rail.clientWidth, n = dots.childElementCount;
        if (n < 2) return;
        var idx = max <= 0 ? 0 : Math.round(rail.scrollLeft / max * (n - 1));
        [].forEach.call(dots.children, function (d, i) { d.classList.toggle("pt-on", i === idx); });
      };
      var build = function () {
        var overflow = rail.scrollWidth - rail.clientWidth;
        if (overflow < 4 || !rail.clientWidth) {
          dots.style.display = "none";
          if (hint && !hint.__ptDone) hint.hidden = true;
          return;
        }
        dots.style.display = "flex";
        if (hint && !hint.__ptDone) hint.hidden = false;
        var pages = Math.max(2, Math.ceil(rail.scrollWidth / rail.clientWidth));
        if (dots.childElementCount !== pages) {
          dots.innerHTML = "";
          for (var i = 0; i < pages; i++) dots.appendChild(document.createElement("i"));
        }
        mark();
      };
      var relayout = function () { if (split) syncCmpRows(split); build(); };
      rail.addEventListener("scroll", mark, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(relayout).observe(rail);
      else window.addEventListener("resize", relayout);
      /* re-measure once webfonts land, or the rows are sized from fallback metrics */
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(relayout);
      build();
    });
  }
  initCmpDots(document);
  document.addEventListener("shopify:section:load", function (e) { initCmpDots(e.target); });

  /* press highlight 2a: rotate the whole quote+logo row, opacity only.
     4s per outlet; fade out .45s, swap, fade in. Paused while the tab is
     hidden so a return visit is never mid-crossfade; static first entry
     under reduced motion and without JS. */
  function initPressLine(root) {
    var line = (root || document).querySelector("#pt-pressline");
    if (!line || line.__ptRot) return;
    line.__ptRot = true;
    var ents = line.querySelectorAll(".pt-pressent");
    /* quotes wrap now, so fit the line to the TALLEST entry once (plus on
       resize and font load) — rotation itself still never moves layout.
       Entries are absolutely stacked, so measure their children: the tallest
       child is the real content height regardless of the container. */
    function fitLine() {
      var need = 0;
      ents.forEach(function (en) {
        [].forEach.call(en.children, function (c) {
          need = Math.max(need, c.getBoundingClientRect().height);
        });
      });
      if (need) line.style.height = Math.round(Math.max(26, need) + 28) + "px";
    }
    fitLine();
    window.addEventListener("load", fitLine);
    var rzt = null;
    window.addEventListener("resize", function () {
      clearTimeout(rzt); rzt = setTimeout(fitLine, 150);
    });
    if (ents.length < 2 || reduced) return;
    var i = 0, t = null;
    function step() {
      ents[i].classList.remove("pt-on");
      i = (i + 1) % ents.length;
      setTimeout(function () { ents[i].classList.add("pt-on"); }, 460);
    }
    /* dwell per outlet is an editor setting (owner 2026-08-19: 4s read too
       fast). The first entry naturally holds a little longer — its clock
       starts at page load. */
    var secs = (parseFloat(line.getAttribute("data-secs")) || 6) * 1000;
    function start() { if (!t) t = setInterval(step, secs); }
    function stop() { if (t) { clearInterval(t); t = null; } }
    document.addEventListener("visibilitychange", function () { if (document.hidden) stop(); else start(); });
    start();
  }
  initPressLine(document);

  // reveal on scroll (additive; content visible without JS)
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (!reduced && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("pt-in"); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll(".pt-rvl").forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll(".pt-rvl").forEach(function (el) { el.classList.add("pt-in"); });
  }

  // Theme Editor re-renders a section's DOM on every setting change; the new
  // nodes arrive in their pre-reveal state with no observer attached, so the
  // section looks blank. Reveal them instantly inside the edited section,
  // and re-run the per-element initializers on the fresh nodes.
  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target || document;
    root.querySelectorAll(".pt-rvl").forEach(function (el) { el.classList.add("pt-in"); });
    if (root.querySelectorAll) { initCarousels(root); initQualRows(root); initPressLine(root); }
    var mcBlob = root.querySelector && root.querySelector("#pt-matcher-data");
    if (mcBlob) { try { MC = JSON.parse(mcBlob.textContent) || {}; } catch (err) { /* keep old config */ } }
  });

  // Gorgias launcher (overlay spec 3a): on the LP the floating bubble shows and
  // hides in step with the sticky add-to-cart pill (see the sticky ATC scroll
  // handler), so it always sits above the pill and never floats alone above the
  // fold. The FAQ's own chat button works the whole time via ptOpenChat().
  // Pages without a buy box show the launcher normally.
  if (!document.getElementById("pt-iatc")) document.documentElement.classList.add("pt-chat-on");

  // carousels: arrows + drag (mouse users are never stranded).
  // Idempotent per row so Theme Editor re-renders can re-run it on fresh DOM.
  function initCarousels(scope) {
    (scope || document).querySelectorAll(".pt-vidrow").forEach(function (row) {
    if (row.__ptCarousel) return;
    row.__ptCarousel = true;
    var wrap = document.createElement("div"); wrap.className = "pt-cwrap";
    row.parentNode.insertBefore(wrap, row); wrap.appendChild(row);
    function mk(dir) {
      var b = document.createElement("button");
      b.className = "pt-cnav " + (dir < 0 ? "pt-l" : "pt-r");
      b.type = "button"; b.textContent = dir < 0 ? "←" : "→";
      b.addEventListener("click", function () {
        var step = row.children[0].getBoundingClientRect().width + 10;
        row.scrollBy({ left: dir * step, behavior: "smooth" });
      });
      wrap.appendChild(b); return b;
    }
    var l = mk(-1), r = mk(1);
    function upd() {
      l.disabled = row.scrollLeft <= 4;
      r.disabled = row.scrollLeft >= row.scrollWidth - row.clientWidth - 4;
    }
    row.addEventListener("scroll", upd, { passive: true });
    window.addEventListener("resize", upd); setTimeout(upd, 150);
    var down = false, moved = false, sx = 0, sl = 0;
    row.style.cursor = "grab";
    row.addEventListener("pointerdown", function (e) {
      if (e.pointerType !== "mouse") return;
      down = true; moved = false; sx = e.clientX; sl = row.scrollLeft;
      row.style.scrollSnapType = "none"; row.style.cursor = "grabbing";
      row.setPointerCapture(e.pointerId);
    });
    row.addEventListener("pointermove", function (e) {
      if (!down) return;
      var dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true;
      row.scrollLeft = sl - dx;
    });
    function end() { if (!down) return; down = false; row.style.scrollSnapType = ""; row.style.cursor = "grab"; }
    row.addEventListener("pointerup", end); row.addEventListener("pointercancel", end);
    row.addEventListener("click", function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    row.addEventListener("dragstart", function (e) { e.preventDefault(); });
    });
  }
  initCarousels(document);

  /* the breakpoint changes the box height, so the overlap has to be recomputed */
  window.addEventListener("resize", function () {
    var prev = $("pt-pkgprev");
    if (prev && prev.querySelector("img")) layoutPkg(prev);
  });

  /* Quality tiles: below 700px the grid becomes a swipe row (pt-page.css).
     Wire the dots to scroll position and add mouse drag-to-scroll, the same
     way .pt-vidrow does — touch scrolls natively, but a mouse cannot drag an
     overflow container without this. Both are guarded on the row actually
     overflowing, so the desktop grid keeps its normal cursor and click
     behaviour. */
  function initQualRows(scope) {
    (scope || document).querySelectorAll(".pt-qualgrid").forEach(function (row) {
      if (row.__ptQual) return;
      row.__ptQual = true;
      var dots = row.parentNode ? row.parentNode.querySelector(".pt-qdots") : null;
      var btns = dots ? [].slice.call(dots.querySelectorAll(".pt-qdot")) : [];

      function scrollable() { return row.scrollWidth - row.clientWidth > 4; }
      function padLeft() { return parseFloat(getComputedStyle(row).paddingLeft) || 0; }
      // live rects, so this is correct mid-scroll and after a resize
      function offsetOf(card) {
        return card.getBoundingClientRect().left - row.getBoundingClientRect().left;
      }
      function activeIndex() {
        var pad = padLeft(), best = 0, bd = Infinity;
        for (var i = 0; i < row.children.length; i++) {
          var d = Math.abs(offsetOf(row.children[i]) - pad);
          if (d < bd) { bd = d; best = i; }
        }
        return best;
      }
      function upd() {
        if (!btns.length) return;
        var a = activeIndex();
        btns.forEach(function (b, i) {
          b.classList.toggle("pt-on", i === a);
          b.setAttribute("aria-current", i === a ? "true" : "false");
        });
      }
      row.addEventListener("scroll", upd, { passive: true });
      window.addEventListener("resize", upd);
      setTimeout(upd, 120);

      btns.forEach(function (b, i) {
        b.addEventListener("click", function () {
          var card = row.children[i]; if (!card) return;
          row.scrollTo({ left: row.scrollLeft + offsetOf(card) - padLeft(), behavior: "smooth" });
        });
      });

      var down = false, moved = false, sx = 0, sl = 0;
      row.addEventListener("pointerdown", function (e) {
        if (e.pointerType !== "mouse" || !scrollable()) return;
        down = true; moved = false; sx = e.clientX; sl = row.scrollLeft;
        row.style.scrollSnapType = "none"; row.style.cursor = "grabbing";
        row.setPointerCapture(e.pointerId);
      });
      row.addEventListener("pointermove", function (e) {
        if (!down) return;
        var dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true;
        row.scrollLeft = sl - dx;
      });
      function end() {
        if (!down) return;
        down = false; row.style.scrollSnapType = ""; row.style.cursor = "";
      }
      row.addEventListener("pointerup", end);
      row.addEventListener("pointercancel", end);
      row.addEventListener("click", function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
      row.addEventListener("dragstart", function (e) { e.preventDefault(); });
    });
  }
  initQualRows(document);

  // anatomy hotspots — scoped to the hotspot's own section so a second
  // pt-engineered instance updates its own label, not the first one's
  function showHotspot(h) {
    if (!h) return;
    var scope = h.closest(".pt-scope") || document;
    var n = h.dataset.n;
    scope.querySelectorAll(".pt-hot, .pt-dot").forEach(function (x) {
      var on = x.dataset.n === n;
      x.classList.toggle("pt-on", on);
      if (x.classList.contains("pt-hot")) x.setAttribute("aria-pressed", on ? "true" : "false");
    });
    scope.querySelectorAll(".pt-lead, .pt-lead-halo, .pt-lead-pulse").forEach(function (l) {
      l.classList.toggle("pt-on", l.dataset.n === n);
    });
    // every part's copy is already in the panel, stacked — just reveal the right one
    scope.querySelectorAll(".pt-xitem").forEach(function (it) {
      it.classList.toggle("pt-on", it.dataset.n === n);
    });
  }

  document.addEventListener("click", function (e) {
    var h = e.target.closest && e.target.closest(".pt-hot, .pt-dot");
    if (h) showHotspot(h);
  });

  // pointing at a number lights its dot and leader line as well, so the three read
  // as one part. Pointer devices only — on a touchscreen the class would stick
  // after the tap.
  if (window.matchMedia && window.matchMedia("(hover:hover)").matches) {
    var hoverHotspot = function (e, on) {
      var h = e.target.closest && e.target.closest(".pt-hot, .pt-dot");
      if (!h) return;
      var scope = h.closest(".pt-scope") || document;
      scope.querySelectorAll(".pt-hot, .pt-dot, .pt-lead").forEach(function (x) {
        if (x.dataset.n === h.dataset.n) x.classList.toggle("pt-hi", on);
      });
    };
    document.addEventListener("mouseover", function (e) { hoverHotspot(e, true); });
    document.addEventListener("mouseout", function (e) { hoverHotspot(e, false); });
  }

  // Theme Editor: picking a hotspot block in the sidebar shows THAT hotspot in the
  // preview. Without this the panel keeps whatever was last clicked, so the copy on
  // screen belongs to a different block than the one being edited.
  document.addEventListener("shopify:block:select", function (e) {
    var el = e.target, h = null;
    if (el && el.classList && el.classList.contains("pt-hot")) h = el;
    else if (el && el.querySelector) h = el.querySelector(".pt-hot");
    if (!h && e.detail && e.detail.blockId) {
      h = document.querySelector('.pt-hot[data-block-id="' + e.detail.blockId + '"]');
    }
    showHotspot(h);
  });

  // best-for blog pills — delegated + per-section scoped (duplicate-safe,
  // survives Theme Editor re-renders)
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest(".pt-tags button");
    if (!b) return;
    var tagRow = b.closest(".pt-tags");
    var scope = b.closest(".pt-scope") || document;
    var card = scope.querySelector(".pt-blogcard");
    var wasOpen = b.classList.contains("pt-sel");
    tagRow.querySelectorAll("button").forEach(function (x) { x.classList.remove("pt-sel"); });
    /* class, not inline display: an inline style would outrank .pt-open and the
       panel could never be reopened */
    if (wasOpen) { if (card) card.classList.remove("pt-open"); return; }
    b.classList.add("pt-sel");
    if (!card) return;
    /* every card is already rendered: reveal the one that matches. The CSS
       crossfade keeps the panel covered, so nothing has to be rebuilt here. */
    var wasClosed = !card.classList.contains("pt-open");
    card.querySelectorAll(".pt-bcard").forEach(function (c) {
      c.classList.toggle("pt-on", c.dataset.n === b.dataset.n);
    });
    card.classList.add("pt-open");
    /* opening from nothing gets the bundle preview's 240ms ease-out. Switching
       between topics must not: fading the panel as a whole would dip it to
       transparent with the new card already inside it, which is the blink. */
    if (wasClosed && !reduced && card.animate) {
      card.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 240, easing: "ease-out" });
    }
  });

  // (v2.3) FAQ chat button: open whichever chat app is present; else fallback link
  window.ptOpenChat = function (btn) {
    try {
      if (window.GorgiasChat && window.GorgiasChat.open) return window.GorgiasChat.open();
      if (window.tidioChatApi && window.tidioChatApi.open) return window.tidioChatApi.open();
      if (window.zE) { try { window.zE("messenger", "open"); } catch (e1) { window.zE("webWidget", "open"); } return; }
      if (window.$crisp && window.$crisp.push) return window.$crisp.push(["do", "chat:open"]);
      if (window.HubSpotConversations && window.HubSpotConversations.widget) return window.HubSpotConversations.widget.open();
    } catch (e) { /* fall through to fallback link */ }
    /* No btn (the matcher's dead-end calls this bare) or no url on it: borrow
       the fallback URL from any chat button on the page that carries one, so
       "Chat with us" still leads somewhere when no chat app has loaded. */
    var src = (btn && btn.dataset && btn.dataset.fallbackUrl) ? btn : document.querySelector("[data-fallback-url]");
    var url = src && src.dataset ? safeUrl(src.dataset.fallbackUrl) : "";
    if (url) window.location.href = url;
  };

  /* "In the box" mobile expander (collapsed rows are CSS-hidden ≤899px only) */
  window.ptInboxToggle = function (btn) {
    var box = btn ? btn.closest(".pt-inbox") : null;
    if (!box) return;
    var ul = box.querySelector("ul");
    var tgl = box.querySelector(".pt-inbox-tgl");
    var willOpen = !box.classList.contains("pt-open");

    /* Animate between the two heights. The rows are display:none when closed,
       so the list snapped from one height to the other — measure both, then let
       the browser interpolate. Height is animated rather than transformed
       because everything below has to move with it. */
    if (ul && ul.animate && !reduced) {
      var from = ul.getBoundingClientRect().height;
      box.classList.toggle("pt-open", willOpen);
      var to = ul.getBoundingClientRect().height;
      box.classList.toggle("pt-open", !willOpen);          /* back, to animate from */
      /* force the pre-state to be laid out before the class flips for real */
      void ul.offsetHeight;
      box.classList.toggle("pt-open", willOpen);
      if (ul.__ptAnim) ul.__ptAnim.cancel();
      ul.style.overflow = "hidden";
      ul.__ptAnim = ul.animate(
        [{ height: from + "px" }, { height: to + "px" }],
        { duration: 260, easing: "cubic-bezier(.22,.8,.3,1)" }
      );
      /* A timer clears up as well as the event. Animations do not advance in a
         backgrounded tab, so onfinish may never arrive — and this one leaves the
         list clipped by overflow:hidden while it waits, which would hide the
         contents the shopper just asked to see. Same belt-and-braces the
         quantity panel uses. */
      var done = function () {
        ul.style.overflow = "";
        ul.style.height = "";
        if (ul.__ptAnim) ul.__ptAnim = null;
      };
      ul.__ptAnim.onfinish = ul.__ptAnim.oncancel = done;
      setTimeout(done, 420);
    } else {
      box.classList.toggle("pt-open", willOpen);
    }

    if (tgl) {
      tgl.setAttribute("aria-expanded", willOpen ? "true" : "false");
      var mark = tgl.querySelector("span");
      if (mark) mark.textContent = willOpen ? "−" : "+";
    }
  };
  /* The rows themselves are the obvious thing to press — a shopper reaching for
     "9 × pairs of Adapters" expects it to open, not to have to find the link
     underneath. Delegated so it survives the editor re-rendering the buy box. */
  document.addEventListener("click", function (e) {
    if (!e.target.closest) return;
    if (e.target.closest(".pt-inbox-tgl")) return;          /* the button has its own handler */
    var li = e.target.closest(".pt-scope .pt-inbox li");
    if (!li) return;
    var box = li.closest(".pt-inbox");
    if (!box || !box.querySelector(".pt-inbox-tgl")) return; /* nothing to expand */
    if (!window.matchMedia("(max-width:899px)").matches) return;
    window.ptInboxToggle(box.querySelector(".pt-inbox-tgl"));
  });

  /* scroll helpers: defined up here (not in the buy-box block) because other
     sections call them — pt-final-cta's button uses ptToBuy(), and both must
     stay safe no-ops when the buy box / reviews section is absent */
  window.ptToBuy = function (openMatcher) {
    var t = $("pt-iatc") || document.querySelector(".pt-buy");
    /* Scroll BEFORE opening: the sheet pins the body, so a scroll issued after
       it cannot move, and closing would drop the shopper back where they were. */
    /* The instant scroll exists only because the sheet pins the body mid-glide.
       Decide whether the sheet is actually going to open — a page with no phone
       matcher, like the 2024 kit, has nothing to pin and should glide. */
    var willOpen = !!(openMatcher && window.ptOpenSheet && document.getElementById("pt-sheet"));
    if (t) {
      try { t.scrollIntoView({ behavior: (reduced || willOpen) ? "instant" : "smooth", block: "center" }); }
      catch (err) { /* the sheet still matters more than the scroll */ }
    }
    /* The final CTA says "choose my fit" — same promise as the one lower down
       the page, so it opens the same sheet rather than only scrolling. */
    if (willOpen) window.ptOpenSheet();
  };
  /* In-page anchors (the hero CTA is href="#pt-buy") jump instantly and land
     under the sticky header. Intercept them so they use the same reduced-motion
     aware scroll the buttons already use; the href stays for no-JS. */
  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest('.pt-scope a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute("href").slice(1);
    if (!id) return;
    var t = document.getElementById(id);
    if (!t) return;
    e.preventDefault();
    var opensSheet = a.hasAttribute("data-pt-openmatch") && window.ptOpenSheet;
    /* try/catch for the same reason as every other scrollIntoView here: the
       default is already cancelled, so a throwing scroll would leave the tap
       doing nothing at all */
    if (!opensSheet) {
      try { t.scrollIntoView({ behavior: reduced ? "instant" : "smooth", block: "start" }); }
      catch (err) {
        try { window.scrollTo(0, t.getBoundingClientRect().top + window.pageYOffset - 90); }
        catch (err2) { /* leave the page where it is */ }
      }
    }
    if (history.replaceState) history.replaceState(null, "", "#" + id);

    /* A link can ask for the phone matcher to open once it arrives, so a button
       that says "choose your fit" actually does that rather than parking the
       visitor next to the control that does.

       It waits for the scroll rather than opening immediately: the sheet focuses
       its input shortly after opening, and focusing an element mid-scroll makes
       the browser abandon the smooth scroll. Closing the sheet would then leave
       the page stranded between sections. scrollend where it exists, a timer
       everywhere else, and whichever fires first wins. */
    if (a.hasAttribute("data-pt-openmatch") && window.ptOpenSheet) {
      /* Opened on a timer once, waiting for the smooth scroll to settle so the
         sheet's focus call could not abort it. That relied on scrollend or on
         rAF running during a scroll, and on iOS — where most of this page's
         traffic lands, via the Instagram browser — neither is dependable, so
         the sheet sometimes never appeared.

         There is nothing to wait for if nothing is animating: the sheet covers
         the page anyway, so the scroll underneath it may as well be instant.
         No timers, no scroll events, nothing to miss. */
      /* Open BEFORE scrolling. Anything the scroll call can throw — an engine
         that rejects behavior:"instant", a detached target — used to take the
         sheet down with it, which is the shape of a failure that shows up on
         one device and not another. The sheet is the promise the button made;
         the scroll is housekeeping behind it. */
      /* Scroll first, then open — but never let the scroll decide whether the
         sheet appears. Opening first looked safer until the scroll lock landed:
         the sheet pins the body at position:fixed, so a scroll issued after it
         goes nowhere and closing the sheet returned the shopper to where they
         started instead of the buy box. Moving first means the lock captures
         the destination, and the try/catch keeps a throwing scroll — an engine
         that rejects behavior:"instant", a detached target — from taking the
         sheet down with it. */
      try { t.scrollIntoView({ behavior: "instant", block: "start" }); }
      catch (err) {
        try { window.scrollTo(0, t.getBoundingClientRect().top + window.pageYOffset - 90); }
        catch (err2) { /* leave the page where it is; the sheet is what matters */ }
      }
      window.ptOpenSheet();
    }
  });

  window.ptToRev = function () {
    var el = document.getElementById((D && D.reviewsAnchor) || "pt-reviews");
    if (!el) return;
    try { el.scrollIntoView({ behavior: reduced ? "instant" : "smooth" }); }
    catch (err) {
      try { window.scrollTo(0, el.getBoundingClientRect().top + window.pageYOffset - 90); }
      catch (err2) { /* leave the page where it is */ }
    }
  };

  // toast (prefers the buy box's #pt-toast; falls back to the matcher
  // section's #pt-mtoast on pages without a buy box)
  var tt, tt2;
  function toast(m) {
    /* re-measure: the bar's height changes with its label, and the toast has
       none until it has content */
    /* The toast can appear while the page is still travelling — a match closes
       the sheet and then scrolls to the buy box — so its target moves under it.
       Re-place through the whole of that journey rather than once at the start. */
    [0, 120, 420, 900, 1400].forEach(function (d) {
      setTimeout(function () { try { fitStickyBar(); } catch (e) {} }, d);
    });
    var toastEl = $("pt-toast") || $("pt-mtoast");
    if (!toastEl) return;
    clearTimeout(tt); clearTimeout(tt2);
    toastEl.innerHTML = m; toastEl.style.display = "block";
    requestAnimationFrame(function () { toastEl.style.opacity = 1; });
    tt = setTimeout(function () {
      toastEl.style.opacity = 0;
      tt2 = setTimeout(function () { toastEl.style.display = "none"; }, 500);
    }, 3400);
  }

  /* ---------- phone matcher (its own section; buy box optional) -----
     Rows come from the fit-db repo's fit-data.json artifact:
     {id, brand, model, aliases[], fit: standard|slim|ask|contact, rank}
     (legacy {n,f,k} fallback rows still work). The purchase flow NEVER
     shows mm numbers - fit resolves from the data + one case question. */
  var MODELS = null, PENDING = null;
  function mcTxt(key, dKey, fallback) {
    if (MC && MC[key] != null && MC[key] !== "") return MC[key];
    if (D && dKey && D[dKey] != null && D[dKey] !== "") return D[dKey];
    return fallback;
  }
  function mcFitLabel(fitKey) {
    if (fitKey === "slim") return mcTxt("fitSlimLabel", "fitSlim", "Slim Fit");
    return mcTxt("fitStdLabel", "fitStd", "Standard Fit");
  }
  function normFit(f) {
    /* fail SAFE: tolerate case/whitespace drift from the remote data, and
       route anything unrecognized to the human "contact" path instead of
       confidently claiming Standard Fit (audit fix, owner-approved 2026-07-27) */
    f = String(f == null ? "" : f).trim().toLowerCase();
    if (f === "std" || f === "standard") return "standard";
    if (f === "slim" || f === "ask" || f === "contact") return f;
    return "contact";
  }
  function normalizeModels(list) {
    return (list || []).map(function (m) {
      if (m.model) {
        /* full "Brand Model" name: model-only reads too bare for short
           names ("15 Ultra") - owner call 2026-07-27 */
        return { id: m.id, name: (m.brand ? m.brand + " " + m.model : m.model), fit: normFit(m.fit),
                 brand: String(m.brand || "").toLowerCase(),
                 img: safeUrl(m.img || ""),
                 search: (m.aliases || []).concat([String(m.brand + " " + m.model).toLowerCase()]) };
      }
      return { id: m.id || null, name: m.n, fit: normFit(m.f),
               img: "",
               search: [String(m.k || m.n).toLowerCase()] };
    });
  }
  var LOADING_CBS = null;   /* in-flight fetch: queue callbacks, never fetch twice */
  function loadModels(cb) {
    if (MODELS) { cb(); return; }
    if (LOADING_CBS) { LOADING_CBS.push(cb); return; }
    LOADING_CBS = [cb];
    var done = function (list) {
      MODELS = normalizeModels(list);
      var q = LOADING_CBS; LOADING_CBS = null;
      q.forEach(function (f) { f(); });
    };
    var dbUrl = safeUrl(MC.fitDbUrl || (D && D.fitDbUrl));
    /* Shopify's file CDN pins the bare URL to cached bytes long after an
       in-place update (verified 2026-07-25: only the ?v= param is a real
       cache key; other params are normalized away). An hourly ?v= bucket
       means the matcher is at most ~an hour behind a database update while
       still hitting the CDN cache in between. */
    if (dbUrl) {
      var hour = Math.floor(Date.now() / 3600000);
      dbUrl += (dbUrl.indexOf("?") === -1 ? "?v=h" : "&v=h") + hour;
    }
    if (dbUrl) {
      fetch(dbUrl).then(function (r) { return r.json(); })
        .then(function (j) { done(j.models || j); })
        .catch(function () { done(FALLBACK_MODELS); });
    } else { done(FALLBACK_MODELS); }
  }
  function sheetMode(mode) {
    var panels = { search: "pt-msearch", ask: "pt-mcase", contact: "pt-mcontact" };
    Object.keys(panels).forEach(function (k) {
      var el = $(panels[k]); if (el) el.style.display = (k === mode) ? "block" : "none";
    });
  }
  /* open/close ease in and out (was an instant pop — owner round 3).
     display + .pt-open class two-step so the CSS transition can run;
     reduced motion skips straight to the open state. */
  var sheetHideT, sheetTrigger = null;
  /* focus trap: Tab cycles inside the open sheet; close returns focus to
     whatever opened it (a11y audit fix, 2026-07-25) */
  function sheetFocusables(s) {
    return Array.prototype.filter.call(
      s.querySelectorAll("button, input, [href], [tabindex]:not([tabindex='-1'])"),
      function (el) { return el.offsetParent !== null && !el.disabled; }
    );
  }
  function sheetTrapKey(e) {
    if (e.key !== "Tab") return;
    var s = $("pt-sheet");
    if (!s || s.style.display === "none") return;
    var f = sheetFocusables(s);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || !s.contains(document.activeElement))) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && (document.activeElement === last || !s.contains(document.activeElement))) {
      e.preventDefault(); first.focus();
    }
  }
  /* The Borders wrapper (.main-container) sets position:relative with
     z-index:0, which makes it a stacking context - so the sheet's z-index only
     ever competes INSIDE that wrapper, and a consent banner mounted on <body>
     paints over the sheet no matter how large a number we pick. Lift the
     overlay nodes to <body> so they compete in the root stacking context,
     where a dialog the shopper deliberately opened belongs. Done on open
     rather than once at init so a Theme Editor re-render, which builds a fresh
     sheet inside the section, is handled too. */
  function portalOverlays() {
    ["pt-mask", "pt-sheet"].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      var kids = document.body.children;
      for (var i = kids.length - 1; i >= 0; i--) {
        if (kids[i].id === id && kids[i] !== el) kids[i].remove();   /* stale copy */
      }
      /* .pt-scope carries every design token, the font and the box-sizing
         reset. Moving out of it left background:var(--pt-paper) resolving to
         nothing and the sheet rendering transparent, so the scope travels
         with the node. Also keeps the customizer's colour overrides applying,
         since those are written as `html .pt-scope{...}`. */
      if (!el.classList.contains("pt-scope")) el.classList.add("pt-scope");
      if (el.parentElement !== document.body) document.body.appendChild(el);
    });
  }

  var sheetScrollY = 0;
  /* Move the overlays out to <body> once, at load. Doing it on the first open
     reparented two elements mid-gesture, which is a repaint the shopper sees. */
  try { portalOverlays(); } catch (e) { /* markup may not be on this page */ }
  /* prefill: a search string to open the sheet already filtered on (the
     support page hands over what was typed in its own search box) */
  window.ptOpenSheet = function (prefill) {
    portalOverlays();
    var m = $("pt-mask"), s = $("pt-sheet");
    if (!s) return;
    clearTimeout(sheetHideT);
    sheetTrigger = (document.activeElement && document.activeElement !== document.body) ? document.activeElement : null;
    document.addEventListener("keydown", sheetTrapKey, true);
    /* chat launchers (Gorgias et al) float at near-max z-index, above any
       modal - hide the bubble while the sheet is open */
    document.documentElement.classList.add("pt-msheet-open");
    /* Hold the page still. Scrolling inside the sheet used to chain through to
       the page, so picking a phone dropped the shopper somewhere else entirely.
       The offset is restored on close. */
    sheetScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.style.top = (-sheetScrollY) + "px";
    document.body.classList.add("pt-sheet-lock");
    if (m) m.style.display = "block";
    s.style.display = "block";
    sheetMode("search");
    /* Force the closed state to be laid out BEFORE the class that animates away
       from it. Waiting two frames instead left a gap in which the sheet was
       already display:block at its start transform, and on iOS the transition
       could be skipped altogether — the sheet appearing to blink rather than
       rise. Reading offsetHeight flushes the layout synchronously, so the
       browser has a state to animate from and the class can go on in the same
       tick. */
    var show = function () { if (m) m.classList.add("pt-open"); s.classList.add("pt-open"); };
    if (reduced) show();
    else { void s.offsetHeight; if (m) void m.offsetHeight; show(); }
    var inp = s.querySelector("input");
    if (inp && typeof prefill === "string") inp.value = prefill;
    if (inp) setTimeout(function () { inp.focus(); }, reduced ? 50 : 240);
    renderModels(inp ? inp.value : "");   /* immediate: loading hint until data lands */
    loadModels(function () { renderModels((s.querySelector("input") || {}).value || ""); });
  };
  window.ptCloseSheet = function () {
    var m = $("pt-mask"), s = $("pt-sheet");
    if (!s) return;
    document.removeEventListener("keydown", sheetTrapKey, true);
    document.documentElement.classList.remove("pt-msheet-open");
    if (document.body.classList.contains("pt-sheet-lock")) {
      document.body.classList.remove("pt-sheet-lock");
      document.body.style.top = "";
      window.scrollTo(0, sheetScrollY);
    }
    if (m) m.classList.remove("pt-open");
    s.classList.remove("pt-open");
    var hide = function () { if (m) m.style.display = "none"; s.style.display = "none"; };
    if (reduced) hide(); else sheetHideT = setTimeout(hide, 340);
    /* return focus to the opener; after a match the opener is hidden
       (the chip replaces it), so fall back to the chip's change button */
    var target = sheetTrigger;
    if (!target || !document.contains(target) || target.offsetParent === null) {
      var lk = $("pt-lk");
      target = (lk && lk.offsetParent !== null) ? lk.querySelector("button") : null;
    }
    if (target && typeof target.focus === "function") target.focus();
    sheetTrigger = null;
  };
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") window.ptCloseSheet(); });
  /* -webkit-user-drag covers Chrome and Safari; Firefox has no such property,
     so the drag is refused here too. Controls only — dragging a gallery photo
     out of the page still works. */
  document.addEventListener("dragstart", function (e) {
    var t = e.target;
    if (t && t.tagName === "IMG" && t.closest && t.closest(".pt-scope") &&
        t.closest('button,a,[role="button"],label')) e.preventDefault();
  }, true);
  window.ptSearchModels = function (q) { renderModels(q); };
  /* For other scripts on the page (the support page's search box): does this
     text look like a phone? cb({rows, family}) — rows are the database hits
     for the text, family is true when its first word is a phone family
     word ("galaxy", "iphone", "pixel", a brand) even if no row matched, so a
     phone we do not list yet can still be pointed at the matcher. */
  var FAMILY = null;
  function familyWords() {
    if (FAMILY) return FAMILY;
    var count = {}, stop = { phone: 1, find: 1, edge: 1, turbo: 1, note: 1, plus: 1, ultra: 1 };
    (MODELS || []).forEach(function (m) {
      if (m.brand) count[m.brand] = 99;
      (m.search || []).forEach(function (a) {
        var w = String(a).split(/\s+/)[0];
        if (/^[a-z]{4,}$/.test(w) && !stop[w]) count[w] = (count[w] || 0) + 1;
      });
    });
    FAMILY = Object.keys(count).filter(function (w) { return count[w] >= 5; });
    return FAMILY;
  }
  /* Resolve one database id straight to a match (the support page's
     best-guess hint): phones that need the case question get the sheet on
     that question, the rest complete at once. */
  window.ptPickPhone = function (id, via) {
    loadModels(function () {
      var row = (MODELS || []).filter(function (m) { return m.id === id; })[0];
      if (!row) return;
      if (row.fit === "ask" || row.fit === "contact") { window.ptOpenSheet(row.name); pickModel(row, via || "hint"); }
      else completeMatch(row, row.fit, null, via || "hint");
    });
  };
  window.ptMatchPhones = function (q, cb) {
    q = String(q || "").trim().toLowerCase();
    if (!q) { cb({ rows: [], family: false }); return; }
    loadModels(function () {
      var rows = (MODELS || []).filter(function (m) { return rowMatches(m, q); });
      var first = q.split(/\s+/)[0];
      cb({ rows: rows, family: familyWords().indexOf(first) !== -1 });
    });
  };
  function rowMatches(m, q) {
    var toks = q.split(/\s+/);
    return m.search.some(function (a) {
      return toks.every(function (t) { return a.indexOf(t) !== -1; });
    });
  }
  function publishMatch(row, fitKey, caseAnswer, via) {
    /* clicks from non-buyers matter (survivorship bias) - fire at match
       time via the Customer Events bus; must never break the flow */
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === "function") {
        Shopify.analytics.publish("pt_fit_match", {
          phone_id: row.id || row.name, fit_shown: fitKey,
          case_answer: caseAnswer || null, via: via
        });
      }
    } catch (e) { /* no-op */ }
  }
  function completeMatch(row, fitKey, caseAnswer, via) {
    /* apply BEFORE closing so the close-time focus restore sees the final
       UI state (the entry button may hide in favor of the matched chip) */
    if (window.__ptApplyMatch) {
      /* buy box present: it sets the fit, chip, toast */
      window.__ptApplyMatch(row, fitKey, caseAnswer);
      window.ptCloseSheet();
      /* The fit is chosen; colour and Add to cart are the next two steps, so
         put them on screen rather than returning the shopper to wherever the
         page happened to be when they opened the sheet. After the close, so it
         is not fighting the scroll-lock restore. */
      setTimeout(function () {
        /* Arriving from a link (menu / support page ?model=): land with the
           "Select your fit" label just under the sticky header, so the fit
           cards, the matched line and the colours read top-down (owner). */
        if (via === "link") {
          var lbl = document.querySelector("#pt-buy .pt-mlbl") || document.getElementById("pt-buy");
          if (lbl) {
            var hh = 0;
            document.querySelectorAll("header.shopify-section, .shopify-section-group-header-group").forEach(function (el) {
              var cs = getComputedStyle(el); if (cs.position === "sticky" || cs.position === "fixed") hh = Math.max(hh, el.getBoundingClientRect().height);
            });
            var y = lbl.getBoundingClientRect().top + window.pageYOffset - hh - 14;
            try { window.scrollTo({ top: y, behavior: reduced ? "auto" : "smooth" }); } catch (e) { window.scrollTo(0, y); }
            setTimeout(function () { if (Math.abs(lbl.getBoundingClientRect().top - hh - 14) > 8) window.scrollTo(0, lbl.getBoundingClientRect().top + window.pageYOffset - hh - 14); }, 700);
            return;
          }
        }
        /* Aim at the shipping line and pull it to the BOTTOM of the screen.
           Centring the swatches instead left the press logos on screen and
           pushed the product photo off the top, so the colour being chosen
           could not be seen changing. Ending on the delivery line puts the
           photo, the swatches and Add to cart all above it. */
        var target = document.getElementById("pt-deldate") || document.getElementById("pt-iatc");
        var block = document.getElementById("pt-deldate") ? "end" : "center";
        if (!target) return;
        try { target.scrollIntoView({ behavior: reduced ? "instant" : "smooth", block: block }); }
        catch (err) { try { target.scrollIntoView(false); } catch (e2) {} }
      }, reduced ? 0 : 380);
    } else {
      window.ptCloseSheet();
      /* standalone (no buy box on this page): there is no matched line to
         animate, so the toast is the only report the shopper gets and it stays.
         It uses the same operator-editable template as before. */
      toast(esc(String(D.txtToast || "[[phone]] → [[fit]]")
        .replace("[[phone]]", row.name).replace("[[fit]]", mcFitLabel(fitKey))));
    }
    try {
      document.dispatchEvent(new CustomEvent("pt:fit-match", {
        detail: { phone: row.name, id: row.id || row.name, fit: fitKey, caseAnswer: caseAnswer || null, via: via }
      }));
    } catch (e) { /* optional consumers only */ }
    publishMatch(row, fitKey, caseAnswer, via);
  }
  function pickModel(row, via) {
    if (row.fit === "contact") { sheetMode("contact"); return; }
    if (row.fit === "ask") { PENDING = { row: row, via: via }; sheetMode("ask"); return; }
    completeMatch(row, row.fit, null, via);
  }
  window.ptToggleInfo = function (btn) {
    // tap-to-expand helper (no hover tooltips); separate 44px target so
    // opening the info never selects the option. Animated via .pt-open.
    var wrap = btn.closest(".pt-mcaseopt");
    var exp = wrap ? wrap.querySelector(".pt-mcaseexp") : null;
    if (!exp) return;
    var opening = !exp.classList.contains("pt-open");
    exp.classList.toggle("pt-open", opening);
    exp.setAttribute("aria-hidden", opening ? "false" : "true");
    btn.setAttribute("aria-expanded", opening ? "true" : "false");
  };
  window.ptCaseAnswer = function (answer) {
    // two parallel answers (owner, 2026-07-25): no_case -> slim, case -> standard
    if (!PENDING) { window.ptCloseSheet(); return; }
    var fitKey = (answer === "case") ? "standard" : "slim";
    var p = PENDING; PENDING = null;
    completeMatch(p.row, fitKey, answer, p.via);
  };
  function renderModels(q) {
    q = (q || "").trim().toLowerCase();
    var h = $("pt-mlisth");
    if (h) h.textContent = q ? mcTxt("txtResults", "txtResults", "Results") : mcTxt("txtPopular", "txtPopular", "Phones");
    if (MODELS === null) {
      /* database still downloading: show a loading hint, never a false
         "No match" dead-end (slow-3G audit fix). The queued loadModels
         callback re-renders with the current input once data lands. */
      var cl = $("pt-mlist");
      if (cl) {
        cl.innerHTML = "";
        /* Skeleton rows, not a one-line "Loading…". The sheet is sized by its
           content, so a single line opened it short and then jerked taller the
           moment the phone list landed — the sheet visibly resizing under the
           finger that just tapped it. Five placeholder rows stand in at the
           height five real ones will occupy, so it opens once, at its size, and
           fills in. Same shimmer the colour swatches use, so waiting looks the
           same wherever it happens on this page. */
        var skel = document.createElement("div");
        skel.className = "pt-mskel";
        skel.setAttribute("aria-hidden", "true");
        for (var i = 0; i < 5; i++) {
          var row = document.createElement("div");
          row.className = "pt-mskelrow";
          row.innerHTML = '<span class="pt-mskelthumb"></span><span class="pt-mskelbar"></span>';
          skel.appendChild(row);
        }
        cl.appendChild(skel);
        /* announced for screen readers, which get nothing from a shimmer */
        var sr = document.createElement("div");
        sr.setAttribute("role", "status");
        sr.style.cssText = "position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)";
        sr.textContent = mcTxt("txtLoading", "txtLoading", "Loading phones…");
        cl.appendChild(sr);
      }
      return;
    }
    var list = MODELS || [];
    var out;
    if (q) {
      out = list.filter(function (m) { return rowMatches(m, q); });
    } else {
      /* default list: merchant-pinned ids, else top-ranked with a 2-per-brand
         cap so the front page isn't one brand (owner request 2026-07-26) */
      var pin = String(MC.popularIds || "").split(",").map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
      out = [];
      if (pin.length) {
        pin.forEach(function (id) {
          for (var i = 0; i < list.length; i++) { if (list[i].id === id) { out.push(list[i]); break; } }
        });
      }
      if (!out.length) {
        var perBrand = {};
        for (var j = 0; j < list.length && out.length < 5; j++) {
          var b = String(list[j].id || list[j].name || "").split(/[-\s]/)[0];
          if ((perBrand[b] || 0) < 2) { perBrand[b] = (perBrand[b] || 0) + 1; out.push(list[j]); }
        }
      }
    }
    var c = $("pt-mlist"); if (!c) return; c.innerHTML = "";
    if (!out.length) {
      // friendly dead-end: message + a way to reach a human, never nothing
      var d = document.createElement("div");
      d.style.cssText = "padding:14px 2px;font-size:.8rem;color:var(--pt-mut);line-height:1.55";
      d.textContent = mcTxt("txtNoMatch", "txtNoMatch", "No match yet.");
      var b = document.createElement("button");
      b.type = "button"; b.className = "pt-mcasebtn";
      b.textContent = mcTxt("txtContactCta", "txtContactCta", "Chat with us");
      b.addEventListener("click", function () { window.ptCloseSheet(); if (window.ptOpenChat) window.ptOpenChat(); });
      c.appendChild(d); c.appendChild(b);
      return;
    }
    /* Names only. The rows used to carry a Standard/Slim chip, but the phones
       that need a case question or a conversation had nothing to show, so the
       column read as a list with arbitrary gaps - and a shopper cannot tell a
       blank meaning "ask about your case" from one meaning "we do not know".
       Picking a phone answers the question properly on the next screen, which
       is the only place the answer is ever complete. (owner, 2026-08-01) */
    out.slice(0, 30).forEach(function (m) {
      var r = document.createElement("button");   /* real button: keyboard + SR reachable */
      r.type = "button"; r.className = "pt-mr";
      if (m.img) {
        /* phase 7 thumbnail; a broken/blocked image simply disappears
           (neutral chip look) rather than showing a broken-image glyph */
        var im = document.createElement("img");
        im.className = "pt-mrimg"; im.src = m.img; im.alt = "";
        im.loading = "lazy"; im.onerror = function () { this.remove(); };
        r.appendChild(im);
      }
      var nm = document.createElement("span");
      nm.className = "pt-mrname"; nm.textContent = m.name;
      r.appendChild(nm);
      r.addEventListener("click", function () { pickModel(m, "search"); });
      c.appendChild(r);
    });
  }
  /* ?findfit=<term> opens the phone matcher prefilled with the term (the header's
     "All iPhones →" / "Any other phone →" links and the mobile sheet). Empty
     term = open the search. Waits for the page to settle so the sheet's focus
     call does not fight the load scroll. */
  (function () {
    var sp = null;
    try { sp = new URLSearchParams(window.location.search); } catch (e) { return; }
    if (!sp.has("findfit")) return;
    var term = sp.get("findfit") || "";
    var go = function () { if (window.ptOpenSheet) window.ptOpenSheet(term); };
    if (document.readyState === "complete") setTimeout(go, 350); else window.addEventListener("load", function () { setTimeout(go, 350); });
  })();

  /* ?model= ad deep links resolve through the same aliases. &case=case|no_case
     carries an answer already given elsewhere (the support page's matcher),
     so a phone that needs the case question is not asked it twice. */
  (function () {
    var q = null, caseAns = null;
    try {
      var sp = new URLSearchParams(window.location.search);
      q = sp.get("model"); caseAns = sp.get("case");
    } catch (e) { return; }
    if (!q) return;
    q = q.trim().toLowerCase();
    if (caseAns !== "case" && caseAns !== "no_case") caseAns = null;
    loadModels(function () {
      var list = MODELS || [];
      var row = null;
      for (var i = 0; i < list.length; i++) {
        /* the database id (what the support page's shop link sends) or an exact alias */
        if (list[i].id === q || list[i].search.indexOf(q) !== -1) { row = list[i]; break; }
      }
      if (!row) { row = list.filter(function (m) { return rowMatches(m, q); })[0] || null; }
      if (!row) return;
      if (row.fit === "ask" && caseAns) {
        completeMatch(row, caseAns === "case" ? "standard" : "slim", caseAns, "link");
      } else if (row.fit === "ask" || row.fit === "contact") {
        window.ptOpenSheet();
        pickModel(row, "link");
      } else {
        completeMatch(row, row.fit, null, "link");
      }
    });
  })();

  /* ---------- buy box (needs #pt-data) ---------- */
  if (!D) return;

  /* Shopify's money_format carries one of several placeholders, and which one
     depends on the market's currency: the US store sends "${{amount}}" but a
     euro market sends "€{{amount_with_comma_separator}}", Switzerland sends an
     apostrophe separator, and so on. Matching only {{amount}} meant the replace
     silently missed and the raw placeholder was printed to the shopper — seen
     live on the German market, 2026-08-21. Each placeholder also dictates its
     own grouping and decimal marks, so 1.234,56 and 1,234.56 are the same
     amount written for different readers. */
  var MONEY_STYLES = {
    amount:                                   [2, ",", "."],
    amount_no_decimals:                       [0, ",", "."],
    amount_with_comma_separator:              [2, ".", ","],
    amount_no_decimals_with_comma_separator:  [0, ".", ","],
    amount_with_apostrophe_separator:         [2, "'", "."],
    amount_with_space_separator:              [2, " ", ","],
    amount_no_decimals_with_space_separator:  [0, " ", ","]
  };
  var money = function (cents) {
    var fmt = D.moneyFormat || "${{amount}}";
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return fmt;
    var st = MONEY_STYLES[m[1]] || MONEY_STYLES.amount;
    var num = Number(cents);
    if (!isFinite(num)) num = 0;
    var parts = (num / 100).toFixed(st[0]).split(".");
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+$)/g, "$1" + st[1]);
    return fmt.replace(m[0], whole + (parts[1] ? st[2] + parts[1] : ""));
  };
  var round = Math.round;

  // variant lookup: fit + color -> variant (rebuilt on Theme Editor re-renders)
  var VBY = {};
  function buildVBY() {
    VBY = {};
    (D.variants || []).forEach(function (v) { VBY[v.fit + "||" + v.color] = v; });
  }
  buildVBY();
  function variantFor(fit, color) { return VBY[fit + "||" + color]; }

  /* ---- pre-launch layer (spec-prelaunch-mode, 2026-08-19) --------------
     While the master toggle is on AND the launch moment is still ahead,
     every variant's live price is swapped ONCE for its early-bird price,
     right here at the data layer — so the tier math, captions, kit cards,
     package total and both buttons inherit the discount with no second
     code path. The full price is kept alongside as the page-wide "was"
     anchor (one reference, per the owner's single-anchor rule). Rounding
     floors the discount per unit at the cent, matching Liquid's integer
     division and the store's verified checkout behaviour.
     At zero (or on a visitor clock already past launch) plFlip() restores
     the untouched values and re-renders — the same page, no reload. */
  var PL = null, plVisBound = false;
  function plStripClasses() {
    document.querySelectorAll(".pt-pl").forEach(function (el) { el.classList.remove("pt-pl"); });
  }
  function plSetup() {
    if (PL && PL.iv) clearInterval(PL.iv);
    PL = null;
    if (!D.prelaunch) return;
    var t = Date.parse(D.prelaunch.target || "");
    PL = { pct: Number(D.prelaunch.pct) || 0, targetMs: isNaN(t) ? 0 : t, iv: null, active: false, txt: null };
    PL.active = PL.pct > 0 && PL.targetMs > Date.now();
    if (!PL.active) { plStripClasses(); PL = null; return; } /* skew guard: past launch = normal page */
    /* Two automatic PRODUCT discounts cannot both land on one cart line —
       Shopify keeps the larger and drops the other, so an early-bird discount
       and the multi-buy function were never compounding at checkout the way
       this page compounded them (measured 2026-08-21: 3x quoted 23% off, cart
       charged 15%). The fix is to let the discount function own the whole
       ladder, with the compounded totals in pt_tier_pct. When it does, this
       page must NOT also apply the percentage, or it would discount an already
       discounted base. Everything else about pre-order mode stays on: the
       countdown, the button copy, the badge, the ship date, the flip at zero. */
    if (!D.prelaunch.fnPricing) {
      (D.variants || []).forEach(function (v) {
        v.fullCents = v.priceCents;
        v.priceCents = v.priceCents - Math.floor(v.priceCents * PL.pct / 100);
      });
    } else {
      (D.variants || []).forEach(function (v) { v.fullCents = v.priceCents; });
    }
    PL.txt = { add: D.txtAdd, bundle: D.txtAddBundle, n: D.txtAddN };
    D.txtAdd = D.prelaunch.txtBtn || "Pre-order";
    D.txtAddBundle = D.prelaunch.txtBtnBundle || "Pre-order bundle";
    D.txtAddN = D.prelaunch.txtBtnN || "Pre-order {n}";
  }
  function plFlip() {
    /* the zero-flip: hide the pre-order chrome, restore live prices and
       button copy, repaint the money — the first visitor after launch
       never sees 0d 00h 00m 00s */
    if (!PL) return;
    if (PL.iv) { clearInterval(PL.iv); PL.iv = null; }
    var wasActive = PL.active;
    PL.active = false;
    plStripClasses();
    if (wasActive) {
      (D.variants || []).forEach(function (v) {
        if (v.fullCents) { v.priceCents = v.fullCents; v.fullCents = 0; }
      });
      if (PL.txt) { D.txtAdd = PL.txt.add; D.txtAddBundle = PL.txt.bundle; D.txtAddN = PL.txt.n; }
      PL = null;
      var row = $("pt-qtyrow"), seg = row && row.__ptSeg;
      if (seg) segApply(Math.max(0, seg.steps.indexOf(S.qty)), false);
      sync();
    } else PL = null;
  }
  function plInitTimer() {
    if (!PL || !PL.active) return;
    var card = $("pt-pltimer");
    var grid = card && card.querySelector(".pt-plt-grid");
    var fb = card && card.querySelector(".pt-plt-fb");
    var els = {};
    if (grid) grid.querySelectorAll("b").forEach(function (b) { els[b.getAttribute("data-u")] = b; });
    var pad = function (n) { return (n < 10 ? "0" : "") + n; };
    function tick() {
      if (!PL) return;
      var r = PL.targetMs - Date.now();
      if (r <= 0) { plFlip(); return; }
      if (els.d) {
        /* ceil, not floor: during the final second this shows 01, and the
           next tick flips — an all-zero readout can never be painted */
        var s = Math.ceil(r / 1000);
        els.d.textContent = Math.floor(s / 86400);
        els.h.textContent = pad(Math.floor(s % 86400 / 3600));
        els.m.textContent = pad(Math.floor(s % 3600 / 60));
        els.s.textContent = pad(s % 60);
      }
    }
    function start() {
      if (!PL || !PL.active) return;
      if (PL.iv) clearInterval(PL.iv);
      tick();
      if (PL && PL.active) PL.iv = setInterval(tick, 1000);
    }
    if (!plVisBound) {
      plVisBound = true;
      /* pause while the tab is hidden so a long background stay can't
         desync the interval; recompute-from-clock on return */
      document.addEventListener("visibilitychange", function () {
        if (!PL) return;
        if (document.hidden) { if (PL.iv) { clearInterval(PL.iv); PL.iv = null; } }
        else start();
      });
    }
    if (grid && fb) { grid.hidden = false; fb.hidden = true; }
    start();
  }
  /* ---- sale layer (2026-08-26) -----------------------------------------
     A Shopify automatic discount is invisible to Liquid and to this script, so
     a product carrying one advertised its full price on the page and revealed
     the real one only in the cart — the 2024 kit read $70.00 while checkout
     charged $45.50. salePct mirrors that discount's percentage purely for
     DISPLAY; it creates nothing and changes nothing at checkout.

     Deliberately the same in-place transform the pre-launch layer uses, so
     every downstream price — unit, bundle, tier ladder, sticky bar — follows
     from this one place, and fullCents keeps the original for the strike.
     Floored per unit at the cent to match how the discount itself rounds.

     The fullCents guard is what stops it compounding: if the pre-launch layer
     has already taken its cut, that variant is left alone rather than being
     discounted twice off an already-discounted base. */
  var SALE = 0;
  function saleSetup() {
    SALE = Number(D.salePct) || 0;
    if (!SALE) return;
    (D.variants || []).forEach(function (v) {
      if (v.fullCents) return;
      v.fullCents = v.priceCents;
      v.priceCents = v.priceCents - Math.floor(v.priceCents * SALE / 100);
    });
  }
  plSetup();
  saleSetup();
  /* Colours to offer for a fit. Normally the available ones — but if a whole
     region has nothing in stock, returning an empty list took the page apart:
     no swatches (so the loading shimmer ran for ever), no resolved variant, and
     every price fell back to $0.00, including the bundle and multi-buy cards.
     Measured on this store: country=US answers 22 of 22 available, country=CA
     answers 0 of 22, so a Canadian visitor met a page that looked broken rather
     than one that said it could not ship to them.

     Falling back to the full range keeps the page whole and honest: the colours
     and the real price show, and sold-out state is reported by the CTA. */
  function colorsFor(fit) {
    var all = (D.colors || []).filter(function (c) { return !!variantFor(fit, c.name); });
    var free = all.filter(function (c) {
      var v = variantFor(fit, c.name); return v && v.available;
    });
    return free.length ? free : all;
  }
  /* true when nothing in this fit can be bought at all — a region problem, not
     a single sold-out colour */
  /* A colour the shopper is allowed to land on. Normally that means in stock —
     but where a whole region has no stock, every colour is offered (see
     colorsFor) and the selection has to follow, or the choice silently does
     nothing. Availability alone was the test, so in Canada picking a colour
     moved the swatch and the label while the package preview and the cart line
     kept the colour the page opened with. */
  function selectable(fit, color) {
    var v = variantFor(fit, color);
    return !!v && (v.available || fitSoldOut(fit));
  }
  function fitSoldOut(fit) {
    return !(D.colors || []).some(function (c) {
      var v = variantFor(fit, c.name); return v && v.available;
    });
  }

  var S = {
    fit: D.fitStd, color: null, kit: 0, qty: 1,
    units: [], uopen: 0
  };
  // default color: first available in default fit (prefer configured default)
  var avail0 = colorsFor(S.fit);
  S.color = (avail0.find(function (c) { return c.name === D.defaultColor; }) || avail0[0] || { name: "" }).name;
  S.units = [{ fit: S.fit, color: S.color, touched: false, picked: false }];

  function tierPct(n) {
    var pct = 0;
    (D.tiers || []).forEach(function (t) { if (n >= t.minQty && t.pct > pct) pct = t.pct; });
    return pct;
  }
  function tripodCents() { var v = variantFor(S.fit, S.color); return v ? v.priceCents : 0; }
  /* What ONE tripod actually costs, for the places that quote a single unit.
     While the discount function owns the early-bird the qty-1 tier IS the
     early-bird, and it is applied by tierPct rather than baked into priceCents
     — so a card that reads priceCents directly quotes full price next to a
     button that charges 15% less (owner caught this on the euro market,
     2026-08-21). With no qty-1 tier configured tierPct(1) is 0 and this is
     exactly tripodCents(), so it is safe in normal trading too. */
  function tripodUnitCents() {
    var t = tripodCents();
    return t - Math.floor(t * tierPct(1) / 100);
  }
  function remotePairCents() {
    /* Checkout parity: the discount function floors the pair % per unit at
       the cent, same as the tiers. */
    if (!D.remote) return 0;
    return D.remote.priceCents - Math.floor(D.remote.priceCents * (D.pairPct || 0) / 100);
  }
  function unitCents() {
    // bundle unit = tripod + remote at pair % off (live prices)
    var t = tripodCents();
    if (S.kit === 1 && D.remote) t += remotePairCents();
    return t;
  }
  /* ---- ONE reference ("was") price for the whole page ----------------
     There used to be three, and they disagreed in public: the kit card
     struck $115 (tripod at its LIVE price + remote at compare-at), the
     Add-to-cart button struck $122 (both at compare-at), and the quantity
     buttons measured "Save $X" off $108 (both at live price) - three
     different anchors for one bundle, all on screen at once.

     Now the owner picks the anchor once (savings_ref) and every strike and
     every "Save $X" derives from it:
       "compare" (default) - full retail, i.e. each line's compare-at price
       "price"             - the current list price, so savings only ever
                             reflect discounts actually applied at checkout
     Each helper is kit-independent so the two kit cards can price
     themselves regardless of which one is selected. */
  function refOf(priceCents, compareCents) {
    if (D.savingsRef === "price") return priceCents;
    return compareCents || priceCents;
  }
  function tripodRefCents() {
    var v = variantFor(S.fit, S.color);
    /* fullCents exists only while the pre-launch layer is live: the "was"
       anchor is then the real launch-day price, so every strike and Save
       amount states what early birds actually keep. */
    return v ? refOf(v.fullCents || v.priceCents, v.compareCents) : 0;
  }
  function remoteRefCents() {
    return D.remote ? refOf(D.remote.priceCents, D.remote.compareCents) : 0;
  }
  function bundleRefCents() { return tripodRefCents() + remoteRefCents(); }
  function unitRefCents() { return S.kit === 1 ? bundleRefCents() : tripodRefCents(); }
  function tierTotal(n) {
    /* Checkout parity (verified live 2026-07-21): Shopify floors the tier
       discount PER UNIT at the cent, so mirror that exactly — e.g. 5% of
       $49.95 = $2.4975 -> $2.49/unit, 2x total $94.92 (not $94.91).
       The tier % applies ONLY to tripod lines; the remote line gets the
       pair % instead and is never tiered. */
    var t = tripodCents();
    var per = Math.floor(t * tierPct(n) / 100);
    var unit = t - per;
    if (S.kit === 1 && D.remote) unit += remotePairCents();
    return n * unit;
  }

  /* ----- gallery: [fit hero] + universal slides + ONE color slide ----- */
  var track = $("pt-gtrack"), gpos = 0;
  function fitPhotoMode() {
    /* active only when BOTH hero photos are configured (owner 2026-07-27):
       slide 1 shows the selected fit in use (cased phone vs thin phone)
       while the variant slide stays the accurate flat product render */
    return !!(D.fitPhotoStd && D.fitPhotoStd.src && D.fitPhotoSlim && D.fitPhotoSlim.src);
  }
  function slides() {
    var s = (D.universalMedia || []).slice(0, 3).map(function (m) { return { src: m.src, alt: m.alt }; });
    if (fitPhotoMode()) {
      var fp = (S.fit === D.fitSlim) ? D.fitPhotoSlim : D.fitPhotoStd;
      s.unshift({ src: fp.src, alt: fp.alt });
    }
    var v = variantFor(S.fit, S.color);
    if (v && v.image) s.push({ src: v.image, alt: S.color });
    return s;
  }
  /* swap an existing img's picture only AFTER the new one is decoded, so the
     old image stays on screen until the new frame can paint — a src change
     (or DOM rebuild) flashes a blank frame even when the bytes are cached */
  function setImg(img, src, alt) {
    if (img.getAttribute("src") === src) { img.alt = alt; return; }
    var pre = new Image();
    pre.src = src;
    var apply = function () { img.src = src; img.alt = alt; };
    if (pre.decode) { pre.decode().then(apply, apply); }
    else if (pre.complete) { apply(); }
    else { pre.onload = apply; pre.onerror = apply; }
  }
  /* Readiness for a whole set before a DOM swap. load/error plus an explicit
     cached check, never decode() — decode() was observed not settling on an
     already-loaded image elsewhere on this page. The timeout guarantees the swap
     still happens if an image never resolves either way. */
  function whenImagesReady(srcs, cb) {
    var left = srcs.length, fired = false;
    var fire = function () { if (!fired) { fired = true; cb(); } };
    if (!left) return fire();
    var timer = setTimeout(fire, 1500);
    var tick = function () { if (--left <= 0) { clearTimeout(timer); fire(); } };
    srcs.forEach(function (src) {
      var counted = false;
      var fin = function () { if (!counted) { counted = true; tick(); } };
      var im = new Image(); im.decoding = "async";
      im.onload = fin; im.onerror = fin; im.src = src;
      if (im.complete && im.naturalWidth) fin();     /* already cached */
    });
  }
  function renderTrack(keep) {
    if (!track) return;
    var s = slides();
    var cur = track.querySelectorAll(".pt-gslide img");
    if (keep && cur.length === s.length) {
      /* same slide count (every fit/color toggle): update pictures in place,
         never rebuild the DOM — rebuilding is what caused the blank flash */
      s.forEach(function (m, i) { setImg(cur[i], m.src, m.alt); });
      drawDots(s.length); drawThumbs(s);
      return;
    }
    var build = function () {
      track.innerHTML = s.map(function (m, i) {
        return '<div class="pt-gslide"><img src="' + esc(m.src) + '" alt="' + esc(m.alt) + '"' + (i > 0 ? ' loading="lazy"' : "") + ' decoding="async"></div>';
      }).join("");
      if (!keep) gpos = 0;
      requestAnimationFrame(function () { track.scrollTo({ left: gpos * track.clientWidth, behavior: "instant" }); });
      drawDots(s.length); drawThumbs(s);
    };
    /* A changing slide count (a colour with a variant photo replacing one
       without) falls here, and this branch throws the track away wholesale. With
       pictures already on screen, fetch the new set first so the old ones hold
       until the new frame can paint. Nothing on screen yet means first render —
       swap immediately rather than delaying the gallery's first paint. */
    if (cur.length) {
      whenImagesReady(s.map(function (m) { return m.src; }), build);
    } else {
      build();
    }
  }
  function drawDots(n) {
    var d = $("pt-gdots"); if (!d) return; d.innerHTML = "";
    for (var i = 0; i < n; i++) { var el = document.createElement("i"); if (i === gpos) el.className = "pt-on"; d.appendChild(el); }
  }
  function drawThumbs(s) {
    var t = $("pt-thumbs"); if (!t) return;
    var cur = t.querySelectorAll("button img");
    if (cur.length === s.length) {
      /* in-place picture swap: same no-blank-frame treatment as the slides */
      s.forEach(function (m, i) { setImg(cur[i], m.src, ""); });
      return;
    }
    t.innerHTML = "";
    s.forEach(function (m, i) {
      var b = document.createElement("button"); b.type = "button";
      /* The thumbnail's own image is decorative — the button is the control, so
         the name belongs on it. Without one a screen reader announced four
         unlabelled buttons in a row. */
      b.setAttribute("aria-label", (D.txtViewPhoto || "View photo {n}").replace("{n}", i + 1));
      b.setAttribute("aria-pressed", i === gpos ? "true" : "false");
      b.innerHTML = '<img src="' + esc(m.src) + '" alt="" loading="lazy">';
      if (i === gpos) b.classList.add("pt-sel");
      b.addEventListener("click", function () { goSlide(i); });
      t.appendChild(b);
    });
  }
  function goSlide(i) {
    var n = slides().length;
    if (!track || !n) return;   /* zero slides: (i % 0) is NaN and sticks */
    gpos = ((i % n) + n) % n;
    try { track.scrollTo({ left: gpos * track.clientWidth, behavior: reduced ? "instant" : "smooth" }); }
    catch (err) { track.scrollLeft = gpos * track.clientWidth; }
    markSlide();
  }
  /* Safari keeps a snap-carousel's scrollLeft in stale PIXELS when the
     container resizes, so shrinking the window leaves a half-shifted slide
     with the neighbour peeking in (owner, launch-day resize test). Re-align
     to the current slide whenever the track actually changes size — via
     ResizeObserver, which Safari honours even when window-resize timing
     races. Chrome re-snaps on its own and treats this as a no-op. */
  function alignTrack() {
    if (!track || !track.clientWidth) return;
    var want = gpos * track.clientWidth;
    if (Math.abs(track.scrollLeft - want) > 2) {
      try { track.scrollTo({ left: want, behavior: "instant" }); }
      catch (err) { track.scrollLeft = want; }
    }
  }
  var alignT;
  function queueAlign() { clearTimeout(alignT); alignT = setTimeout(alignTrack, 180); }
  window.addEventListener("resize", queueAlign);
  if (track && "ResizeObserver" in window) new ResizeObserver(queueAlign).observe(track);

  /* ---- lightbox (owner 2026-08-20) --------------------------------------
     Tap a gallery photo → full-screen at a 2048px rendition; tap the photo
     again → zoom in anchored at the tapped point, pan by scroll/drag;
     X / Esc / backdrop closes. The standard e-commerce expectation. */
  var lbLastFocus = null;
  function lbEl() {
    var ex = $("pt-lbox"); if (ex) return ex;
    var w = document.createElement("div");
    w.id = "pt-lbox"; w.className = "pt-lbox";
    w.setAttribute("role", "dialog"); w.setAttribute("aria-modal", "true");
    w.innerHTML = '<div class="pt-lbox-scroll" id="pt-lbox-scroll"><img id="pt-lbox-img" alt="" decoding="async"></div>' +
      '<button type="button" class="pt-lbox-x" id="pt-lbox-x" aria-label="Close">&#10005;</button>';
    document.body.appendChild(w);
    $("pt-lbox-x").addEventListener("click", lbClose);
    $("pt-lbox-scroll").addEventListener("click", function (e) {
      if (e.target && e.target.id === "pt-lbox-img") lbToggleZoom(e);
      else lbClose();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && w.classList.contains("pt-on")) lbClose();
    });
    return w;
  }
  function lbToggleZoom(e) {
    var w = $("pt-lbox"), sc = $("pt-lbox-scroll"), img = $("pt-lbox-img");
    var target = Math.round(window.innerWidth * 2.3);
    if (!w.classList.contains("pt-zoom")) {
      /* anchor on the point INSIDE the picture that was tapped — a viewport
         fraction aimed at the wrong content when the fit image didn't fill
         the screen (owner 2026-08-21). Explicit pixel width, not a % of the
         flex container: Safari resolved the percentage against the wrong
         box and barely zoomed. */
      var r = img.getBoundingClientRect();
      var fx = e && r.width ? Math.min(1, Math.max(0, (e.clientX - r.left) / r.width)) : 0.5;
      var fy = e && r.height ? Math.min(1, Math.max(0, (e.clientY - r.top) / r.height)) : 0.5;
      img.__ptFit = Math.round(r.width);       /* remember the size to return to */

      /* Pin the CURRENT size as an explicit length before releasing the
         max-width/max-height that produced it. Fitted, this element's width is
         `auto`, and `auto` to a length is not interpolatable — the transition
         had nothing to animate between, which is why no animation was visible.
         Two lengths, and it moves. */
      w.classList.add("pt-zoom");
      img.style.width = img.__ptFit + "px";
      void img.offsetWidth;                    /* commit that start state */

      /* Go to the final size on whatever file is already decoded, and let the
         sharper one arrive underneath. Capping at the CURRENT file's real
         pixels meant the gesture waited on a download before moving at all. */
      img.style.width = target + "px";
      img.__ptFx = fx; img.__ptFy = fy;

      /* The width animates, so the scroll container grows over the transition
         and a single aim would be clamped against a box that had not finished
         growing. Re-aim across it, then stop — after that the position belongs
         to the visitor. */
      if (img.__ptAim) cancelAnimationFrame(img.__ptAim);
      var t0 = Date.now();
      var follow = function () {
        lbReaim();
        if (Date.now() - t0 < 420) img.__ptAim = requestAnimationFrame(follow);
        else { img.__ptAim = 0; img.__ptFx = null; }   /* hands off from here */
      };
      lbReaim();
      img.__ptAim = requestAnimationFrame(follow);

      /* the gesture that needs the pixels is the one that pays for them */
      lbUpgrade(lbBigWidth());
    } else {
      if (img.__ptAim) { cancelAnimationFrame(img.__ptAim); img.__ptAim = 0; }
      img.__ptFx = null;
      /* animate back down to the fitted size before handing the constraints
         back to CSS — clearing the width outright would snap */
      var fit = img.__ptFit || Math.round(window.innerWidth * 0.96);
      img.style.width = fit + "px";
      var done = function () {
        img.removeEventListener("transitionend", done);
        w.classList.remove("pt-zoom");
        img.style.width = "";
        sc.scrollLeft = 0; sc.scrollTop = 0;
      };
      img.addEventListener("transitionend", done);
      setTimeout(done, 420);                   /* transitions do not fire in a hidden tab */
    }
  }

  /* How wide a file the zoom can actually use.

     This was pinned at 2048. A 4079px master then displayed at 2048 — under
     half its linear resolution — and at 2.3x on a retina screen the browser was
     upscaling, which is the softness the owner spotted against the original.

     The zoom paints the image at innerWidth * 2.3 CSS pixels, so the useful
     pixel count is that times the device ratio. Capped at 3x because no screen
     resolves more, floored so a small phone still gets a real upgrade, and
     ceilinged at Shopify's own 5760 limit. Snapped to 256px steps so visitors
     share CDN cache entries instead of each minting a bespoke rendition.

     Requesting more than the master holds costs nothing: Shopify serves the
     source size and stops — measured, width=5760 on this 4079px file returns
     4079 and the same 761KB as width=4096. */
  function lbBigWidth() {
    var dpr = Math.min(window.devicePixelRatio || 1, 3);
    var need = Math.ceil(window.innerWidth * 2.3 * dpr);
    need = Math.ceil(need / 256) * 256;
    return Math.min(Math.max(need, 1792), 5760);
  }

  /* Enough pixels for the lightbox at rest: the photo is fitted to the screen,
     so its longest painted edge is the smaller viewport dimension. */
  function lbFitWidth() {
    var dpr = Math.min(window.devicePixelRatio || 1, 3);
    var need = Math.ceil(Math.min(window.innerWidth, window.innerHeight) * dpr);
    return Math.min(Math.max(Math.ceil(need / 256) * 256, 1280), 5760);
  }

  /* Swap in a sharper rendition once it has decoded. Shared by the two stages
     so the token, the decode guard and the mid-zoom re-cap exist in one place.
     The token stops a slow upgrade landing on top of a different photo. */
  /* Put the point the visitor tapped back under their finger. Called after the
     width settles and again if a sharper file changes it. */
  function lbReaim() {
    var sc = $("pt-lbox-scroll"), img = $("pt-lbox-img");
    if (!sc || !img || img.__ptFx == null) return;
    sc.scrollLeft = Math.max(0, img.clientWidth * img.__ptFx - window.innerWidth / 2);
    sc.scrollTop = Math.max(0, img.clientHeight * img.__ptFy - window.innerHeight / 2);
  }

  function lbUpgrade(targetW) {
    var w = lbEl(), img = $("pt-lbox-img");
    var cur = parseInt((img.src.match(/[?&]width=(\d+)/) || [0, 0])[1], 10) || 0;
    if (cur >= targetW) return;                       /* already good enough */
    var big = img.src.replace(/([?&])width=\d+/, "$1width=" + targetW);
    if (big === img.src) return;
    if (img.__ptWant === targetW) return;             /* this fetch is already in flight */
    img.__ptWant = targetW;
    var token = (img.__ptTok = (img.__ptTok || 0) + 1);
    var pre = new Image();
    pre.decoding = "async";
    var applied = false;
    var apply = function () {
      if (applied) return;
      applied = true;
      if (img.__ptTok !== token || !w.classList.contains("pt-on")) return;
      img.src = big;
      /* a sharper file raises the ceiling on how far the zoom may magnify */
      if (w.classList.contains("pt-zoom")) {
        /* Hold the visitor's OWN position, not the point they first tapped.
           Re-aiming at the tap point threw away wherever they had panned to in
           the meantime — the picture jumped back the instant the sharp file
           landed. Their scroll is captured as a fraction of the content, so it
           survives the width changing underneath it. */
        var sc = $("pt-lbox-scroll");
        var prevW = img.clientWidth || 1, prevH = img.clientHeight || 1;
        var keepX = sc ? (sc.scrollLeft + window.innerWidth / 2) / prevW : 0.5;
        var keepY = sc ? (sc.scrollTop + window.innerHeight / 2) / prevH : 0.5;
        img.style.width = Math.min(Math.round(window.innerWidth * 2.3),
                                   pre.naturalWidth || targetW) + "px";
        if (sc) {
          sc.scrollLeft = Math.max(0, img.clientWidth * keepX - window.innerWidth / 2);
          sc.scrollTop = Math.max(0, img.clientHeight * keepY - window.innerHeight / 2);
        }
      }
    };
    pre.src = big;
    /* decode() before swapping: a loaded-but-undecoded file painted a black
       frame mid-zoom (owner 2026-08-20), and it came back when this was
       refactored — decode() FIRST, onload only as its fallback. Registering onload
       unconditionally let it win the race, swapping in a file that had loaded
       but not yet decoded — which is the black frame that came back. onload
       fires earlier than decode by design; that earliness is the bug. */
    if (pre.decode) {
      pre.decode().then(apply, function () {
        pre.onload = apply;
        if (pre.complete && pre.naturalWidth) apply();
      });
    } else {
      pre.onload = apply;
      if (pre.complete && pre.naturalWidth) apply();
    }
    /* decode() can hang without settling either way in a backgrounded tab, so
       a timer stands behind both paths. Long enough that it never beats a
       decode that is merely slow. */
    setTimeout(function () { if (pre.complete && pre.naturalWidth) apply(); }, 1500);
  }

  function lbOpen(src, alt) {
    var w = lbEl(), img = $("pt-lbox-img");
    w.classList.remove("pt-zoom");
    img.style.width = "";
    img.__ptWant = 0;
    /* paint the already-decoded 1100px copy IMMEDIATELY — reusing the big
       rendition as the src meant a reopen showed the PREVIOUS photo until
       the new one arrived (owner 2026-08-20). */
    img.src = src;
    img.alt = alt || "";
    /* Only what the fitted view needs. The zoom-grade file is fetched when
       someone actually zooms: pulling it here cost every visitor who opened a
       photo and never pinched — 760KB on a laptop, 344KB on a phone, for
       pixels that view cannot show. */
    lbUpgrade(lbFitWidth());
    w.classList.add("pt-on");
    document.documentElement.classList.add("pt-lbox-lock");
    lbLastFocus = document.activeElement;
    var x = $("pt-lbox-x"); if (x) x.focus();
  }
  function lbClose() {
    var w = $("pt-lbox"); if (!w) return;
    w.classList.remove("pt-on"); w.classList.remove("pt-zoom");
    var li = $("pt-lbox-img"); if (li) li.style.width = "";
    document.documentElement.classList.remove("pt-lbox-lock");
    if (lbLastFocus && lbLastFocus.focus) { try { lbLastFocus.focus(); } catch (e) { /* gone */ } }
  }
  if (track) track.addEventListener("click", function (e) {
    var img = e.target && e.target.closest ? e.target.closest(".pt-gslide img") : null;
    if (img && img.src) lbOpen(img.src, img.alt);
  });
  /* The fit badge is a claim about the photo under it, so it may only appear on
     a photo genuinely shot for one fit. Two slides qualify: the hero at index 0
     in fitPhotoMode, where the owner uploaded a separate Standard and Slim
     photo, and the variant render at the end, which is per fit AND colour —
     every colour has its own Standard and Slim file (-892 / -599), verified
     across all 22 variants. The lifestyle shots between them are the same
     picture in both fits, and badging those told the shopper they were looking
     at fit-specific photography that does not exist (owner 2026-08-21). */
  function fitDedicatedSlide(i) {
    if (fitPhotoMode() && i === 0) return true;
    var v = variantFor(S.fit, S.color);
    return !!(v && v.image && i === slides().length - 1);
  }
  function syncBadge() {
    var badge = $("pt-gbadge"); if (!badge) return;
    badge.textContent = S.fit;
    badge.hidden = !fitDedicatedSlide(gpos);
  }
  function markSlide() {
    syncBadge();
    document.querySelectorAll("#pt-gdots i").forEach(function (el, i) { el.classList.toggle("pt-on", i === gpos); });
    document.querySelectorAll("#pt-thumbs button").forEach(function (el, i) {
      el.classList.toggle("pt-sel", i === gpos);
      el.setAttribute("aria-pressed", i === gpos ? "true" : "false");
    });
  }
  function bindTrack() {
    track = $("pt-gtrack");
    if (!track || track.__ptBound) return;
    track.__ptBound = true;
    var scrollT;
    track.addEventListener("scroll", function () {
      clearTimeout(scrollT);
      scrollT = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== gpos) { gpos = i; markSlide(); }
      }, 80);
    }, { passive: true });
  }
  bindTrack();

  /* ----- swatches (OOS hidden, per fit) ----- */
  function drawSwatches() {
    var box = $("pt-cs"); if (!box) return; box.innerHTML = "";
    colorsFor(S.fit).forEach(function (c) {
      var b = document.createElement("button"); b.type = "button";
      b.title = c.name; b.setAttribute("aria-label", c.name);
      b.setAttribute("aria-pressed", c.name === S.color ? "true" : "false");
      b.innerHTML = c.swatch ? '<img src="' + esc(c.swatch) + '" alt="">' : '<span class="pt-swf" style="background:' + safeHex(c.hex) + '"></span>';
      if (c.name === S.color) b.classList.add("pt-sel");
      b.addEventListener("click", function () {
        S.color = c.name;
        S.units.forEach(function (u) {
          if (!headerOwns(u)) return;          /* leave a deliberate choice alone */
          if (selectable(u.fit, c.name)) u.color = c.name;
        });
        var cn = $("pt-cn"); if (cn) cn.textContent = c.name;
        drawSwatches(); renderTrack(true);
        /* glide to the colour's own photo — only if it exists, so we never
           jump to an unrelated slide (same guard as the fit-click path) */
        var vSel = variantFor(S.fit, S.color);
        if (vSel && vSel.image) goSlide(slides().length - 1);
        renderUnits(); sync();
      });
      box.appendChild(b);
    });
  }

  /* ----- fit ----- */
  /* Who owns a unit's fit and colour: the controls at the top of the buy box,
     or the shopper who opened "Set up each one" and configured that unit?

     Both header controls used to overwrite regardless, and they disagreed about
     how: the colour swatches rewrote EVERY unit, while the fit buttons rewrote
     only the first. So configuring two units and then touching the fit toggle
     out of curiosity left unit 1 Slim and unit 2 Standard — a cart that did not
     match what the shopper had picked, announced by nothing (owner, 2026-08-22).

     A unit the shopper has configured now keeps what they chose; "Make both
     like this" is the deliberate way to overwrite. Untouched units still follow
     the header, which is what makes the top controls feel live. At quantity 1
     the per-unit panel is not on screen, so the header is the only control
     there and must always win. */
  function headerOwns(u) { return S.qty === 1 || !u.touched; }
  function setFit(f) {
    S.fit = f;
    S.units.forEach(function (u) { if (headerOwns(u)) u.fit = f; });
    var pS = $("pt-fp-std"), pL = $("pt-fp-slim");
    if (pS) { pS.classList.toggle("pt-sel", f === D.fitStd); pS.setAttribute("aria-pressed", f === D.fitStd ? "true" : "false"); }
    if (pL) { pL.classList.toggle("pt-sel", f === D.fitSlim); pL.setAttribute("aria-pressed", f === D.fitSlim ? "true" : "false"); }
    var v = variantFor(f, S.color);
    /* selectable, not available: where a region has no stock at all this branch
       fired on every fit switch, announcing "sold out" and throwing the chosen
       colour away each time — noise about a condition the CTA already states
       once, plainly. It still fires for a genuinely sold-out single colour. */
    if (!selectable(f, S.color)) {
      var alt = colorsFor(f)[0];
      if (alt) {
        toast(esc(S.color) + " is sold out in " + esc(f) + ", switched to " + esc(alt.name));
        S.color = alt.name;
        var cn = $("pt-cn"); if (cn) cn.textContent = alt.name;
      }
    }
    syncBadge();
    var bf = $("pt-boxfit"); if (bf) bf.textContent = (f === D.fitStd ? D.boxFitStd : D.boxFitSlim);
    var br = $("pt-boxrange"); if (br) br.textContent = (f === D.fitStd ? D.boxRangeStd : D.boxRangeSlim);
    drawSwatches(); renderTrack(true); renderUnits(); sync();
    /* show the fit visually (owner 2026-07-27): with fit hero photos, glide
       to slide 1 where the cased-phone/thin-phone photo just swapped —
       UNLESS the shopper is looking at the variant photo, in which case stay
       there: the in-place swap just changed it to the same colour in the new
       fit, which is what they came to see (owner 2026-08-20: blue Standard →
       Slim used to yank back to the hero instead of showing slim blue). */
    if (fitPhotoMode()) {
      if (gpos !== slides().length - 1) goSlide(0);
    } else {
      var vSel = variantFor(S.fit, S.color);
      if (vSel && vSel.image) goSlide(slides().length - 1);
    }
  }
  window.ptFitClick = function (f) {
    var lk = $("pt-lk");
    if (lk && lk.style.display === "block" && lk.dataset.f !== f) {
      lk.style.display = "none"; var fn = $("pt-fitnote"); if (fn) fn.style.display = "block";
      // manual override after a match: warn, but never block the choice
      var w = $("pt-fitwarn");
      if (w && S.match) {
        w.textContent = String(D.txtOverrideWarn || "This size may not match your [[phone]].")
          .replace("[[phone]]", S.match.name);
        w.style.display = "block";
      }
    }
    setFit(f);
  };

  /* the matcher calls this when a match completes; the buy box owns the
     fit state, chip, and toast wording */
  window.__ptApplyMatch = function (row, fitKey, caseAnswer) {
    S.match = { id: row.id || row.name, name: row.name, fit: fitKey, caseAnswer: caseAnswer || null };
    var label = (fitKey === "slim") ? D.fitSlim : D.fitStd;
    setFit(label);
    var lk = $("pt-lk");
    if (lk) {
      lk.style.display = "block"; lk.dataset.f = label;
      $("pt-lkf").textContent = label; $("pt-lkm").textContent = row.name;
      /* Restart the reveal every time a match lands, including a re-match where
         the line is already on screen — dropping the class and forcing a reflow
         before re-adding it, or the animation would only ever play once. It is
         taken off at the end so the gradient is not left painted behind static
         text, and so a later re-match starts clean. */
      lk.classList.remove("pt-lk-in");
      void lk.offsetWidth;
      lk.classList.add("pt-lk-in");
      if (lk.__ptLkT) clearTimeout(lk.__ptLkT);
      lk.__ptLkT = setTimeout(function () { lk.classList.remove("pt-lk-in"); }, 3800);
      var fn = $("pt-fitnote"); if (fn) fn.style.display = "none";
    }
    var w = $("pt-fitwarn"); if (w) w.style.display = "none";
    stopMatchSweep();
    /* No toast here. The matched line under the fit cards now rises and washes
       when a match lands, which says the same thing in the place the answer
       actually applies — the toast repeated it in a corner the shopper was not
       looking at (owner, 2026-08-22). The standalone matcher, which has no such
       line, still toasts. */
    sync();
  };

  /* The buy box's markup ships with "Tripod only", "Standard Fit" and the
     Standard gallery badge marked as chosen - correct on a cold load, wrong
     any other time. The Theme Editor re-renders the section on every setting
     change, and the re-render brought those hardcoded states back while S
     still held the shopper's real choice: the cards read "Tripod only" while
     the price, the button label and the composed boxes all stayed on the
     bundle. Everything selected is now drawn from S, on init and re-render
     alike, so the controls can't contradict what's actually being bought. */
  function applySelState() {
    var pairs = [["pt-k0", S.kit === 0], ["pt-k1", S.kit === 1],
                 ["pt-fp-std", S.fit === D.fitStd], ["pt-fp-slim", S.fit === D.fitSlim]];
    pairs.forEach(function (p) {
      var el = $(p[0]); if (!el) return;
      el.classList.toggle("pt-sel", p[1]);
      el.setAttribute("aria-pressed", p[1] ? "true" : "false");
    });
    syncBadge();
    var cn = $("pt-cn"); if (cn) cn.textContent = S.color;
  }

  /* Measure a set of blocks, let fn() rewrite them, then animate each one's
     height between the two measurements. Adding or dropping the remote changes
     the quantity row (the savings line appears) and the "what arrives" line
     (it gains a "+ 4x Remote box" and rewraps), and both used to resize under
     the cursor with no transition. Blocks whose height did not really move
     just get the crossfade, so nothing twitches for the sake of it. */
  function heightSwap(els, fn, fade) {
    if (reduced) { fn(); return; }
    var list = [];
    els.forEach(function (el) { if (el) list.push({ el: el, h: el.getBoundingClientRect().height }); });
    fn();
    list.forEach(function (r) {
      var end = r.el.getBoundingClientRect().height;
      var moved = Math.abs(end - r.h) >= 2;
      if (!moved && !fade) return;
      if (r.el.__ptAnim) r.el.__ptAnim.cancel();
      var from = { opacity: fade ? 0.45 : 1 }, to = { opacity: 1 };
      if (moved) { from.height = r.h + "px"; to.height = end + "px"; r.el.style.overflow = "hidden"; }
      var a = r.el.animate([from, to], { duration: 260, easing: "cubic-bezier(.4,0,.2,1)" });
      r.el.__ptAnim = a;
      var settle = function () { r.el.style.overflow = ""; if (r.el.__ptAnim === a) r.el.__ptAnim = null; };
      a.onfinish = a.oncancel = settle;
      setTimeout(settle, 560);
    });
  }

  /* ----- bundle + tiers + per-unit ----- */
  window.ptBundleTeaser = function () {
    /* smooth-scroll the bundle heading to the top of the view, then pulse
       the bundle card once so the eye lands on the right thing */
    var head = $("pt-bshead"), card = $("pt-k1");
    var target = head || card; if (!target) return;
    /* the theme's sticky header overlays the top of the viewport — land the
       heading just below it, not underneath it (owner 2026-08-20) */
    var hdrH = function () {
      var h = 0;
      document.querySelectorAll("header.shopify-section, .shopify-section-group-header-group").forEach(function (el) {
        var cs = getComputedStyle(el);
        if (cs.position === "sticky" || cs.position === "fixed") h = Math.max(h, el.getBoundingClientRect().height);
      });
      return h;
    };
    var dest = function () { return target.getBoundingClientRect().top + window.pageYOffset - 10 - hdrH(); };
    try { window.scrollTo({ top: dest(), behavior: reduced ? "auto" : "smooth" }); }
    catch (e) { window.scrollTo(0, dest()); }
    setTimeout(function () {
      /* content above (lazy media) can change height mid-scroll and strand
         the landing too low — recompute once settled and snap the last bit */
      if (Math.abs(target.getBoundingClientRect().top - 10 - hdrH()) > 8) window.scrollTo(0, dest());
      if (card && !reduced) {
        card.classList.remove("pt-pulse");
        void card.offsetWidth;                       /* restart cleanly on a second tap */
        card.classList.add("pt-pulse");
        var end = function () { card.classList.remove("pt-pulse"); card.removeEventListener("animationend", end); };
        card.addEventListener("animationend", end);
      }
    }, reduced ? 60 : 700);
  };
  window.ptKit = function (k) {
    S.kit = k;
    applySelState();
    /* only the package line still crossfades - the qty widget now updates
       in place and must not be faded over (it flashed; owner 2026-08-19) */
    heightSwap([$("pt-pkgline")], function () {
      drawQty(); renderUnits(); sync();
    }, true);
  };
  /* Segmented quantity selector (spec-qty-selector, 2026-08-19): one track,
     a sliding pill, a savings meter and a caption replace the four tile cards.
     drawQty() BUILDS the widget (init, kit switch, editor re-render);
     segApply() moves the selection IN PLACE - a rebuild on every tap would
     destroy the pill's glide, which is the whole point of the design. */
  var SEG_COLORS = ["#c8c7a9", "#93a888", "#5f7355", "#43523d"];   /* meter, palest to deepest tier */
  /* "5% off", not "save 5%" - the caption below already says Save, and
     saying it twice reads as an echo (owner 2026-08-19) */
  function segLabelTxt(n) {
    var ref = n * unitRefCents(); var save = ref - tierTotal(n); var v = "";
    if (save > 0) {
      if ((D.qtySaveMode || "percent") === "percent") {
        var pct = ref > 0 ? Math.round(save * 100 / ref) : 0;
        if (pct > 0) v = pct + "%";
      } else { v = money(save); }
    }
    return v ? v + " " + (D.txtOff || "off") : "\u2014";
  }
  function segSaveTxt(n) {
    var ref = n * unitRefCents();
    var save = ref - tierTotal(n);
    if (save <= 0) return "";
    if ((D.qtySaveMode || "percent") === "percent") {
      var pct = ref > 0 ? Math.round(save * 100 / ref) : 0;
      return pct > 0 ? (D.txtSave || "Save") + " " + pct + "%" : "";
    }
    return (D.txtSave || "Save") + " " + money(save);
  }
  function segApply(idx, dragging) {
    var row = $("pt-qtyrow"); var seg = row && row.__ptSeg; if (!seg) return;
    seg.track.classList.toggle("pt-drag", !!dragging);
    seg.pill.style.left = "calc(4px + " + idx + " * (" + seg.cell + " + 4px))";
    seg.fill.style.width = ((idx + 1) / seg.N * 100) + "%";
    seg.fill.style.background = SEG_COLORS[Math.min(idx, SEG_COLORS.length - 1)];
    seg.fill.style.opacity = idx === 0 ? ".45" : "1";
    seg.btns.forEach(function (b, i) {
      b.classList.toggle("pt-sel", i === idx);
      b.setAttribute("aria-checked", i === idx ? "true" : "false");
      b.tabIndex = i === idx ? 0 : -1;
    });
    seg.lblEls.forEach(function (l, i) { l.classList.toggle("pt-sel", i === idx); });
    var n = seg.steps[idx];
    var ref = n * unitRefCents();
    var saveC = ref - tierTotal(n);
    /* caption: the saving in REAL MONEY first (fixed anchor across tiers),
       the stamp trailing. The stamp is a persistent element toggled with a
       class so it can animate in and out (owner 2026-08-19). */
    seg.capSaveEl.innerHTML = idx === 0
      ? esc(D.txtSingle || "Single tripod")
      : (saveC > 0 ? esc(D.txtSave || "Save") + " " + money(saveC) : "");
    var badge = seg.badges[n] || "";
    if (badge) seg.capTagEl.textContent = badge;   /* keep the old text while fading out */
    seg.capTagEl.classList.toggle("pt-on", !!badge);
    seg.capR.innerHTML = money(tierTotal(n)) + (saveC > 0 ? " <s>" + money(ref) + "</s>" : "");
  }
  function selectQty(n) {
    S.qty = n;
    while (S.units.length < n) S.units.push({ fit: S.fit, color: S.color, touched: false, picked: false });
    S.units = S.units.slice(0, n);
    /* re-derive the accordion: keep a valid open row, preferring the first
       unit the shopper hasn't configured yet */
    if (n >= 2 && (S.uopen >= n || S.uopen < 0)) {
      var firstUn = -1;
      S.units.some(function (x, j) { if (!x.touched) { firstUn = j; return true; } return false; });
      S.uopen = firstUn;
    }
    /* Dropping back to a single tripod hides the per-unit rows, so unit 1's
       colour has no visible control any more - yet it is what goes in the
       cart. Left alone, the top swatch could read Matte-Black while the cart
       and the box preview were Alien Blue. Adopt unit 1's choice into the
       top selector so the visible control tells the truth. */
    if (n === 1 && S.units[0]) {
      S.fit = S.units[0].fit;
      S.color = S.units[0].color;
      applySelState();
      drawSwatches(); renderTrack(true);
    }
    var row = $("pt-qtyrow"); var seg = row && row.__ptSeg;
    if (seg) segApply(Math.max(0, seg.steps.indexOf(n)), false);
    renderUnits(); sync();
  }
  function bindSegDrag(track, row) {
    /* The whole track drags like a slider (spec): pointerdown selects the
       column under the pointer, moves keep selecting, pointerup commits.
       Intermediate moves update the visuals only - renderUnits()/sync() run
       once on release, they are too heavy per-move. touch-action:pan-y in the
       CSS keeps vertical page scroll native. */
    track.addEventListener("pointerdown", function (e) {
      if (e.button) return;
      var seg = row.__ptSeg; if (!seg) return;
      var idxFrom = function (ev) {
        var r = track.getBoundingClientRect();
        var x = (ev.touches ? ev.touches[0].clientX : ev.clientX) - r.left;
        return Math.max(0, Math.min(seg.N - 1, Math.floor((x - 4) / ((r.width - 8) / seg.N))));
      };
      var cur = idxFrom(e);
      segApply(cur, true);
      var move = function (ev) { ev.preventDefault(); var i = idxFrom(ev); if (i !== cur) { cur = i; segApply(cur, true); } };
      var up = function () {
        removeEventListener("pointermove", move); removeEventListener("pointerup", up);
        removeEventListener("touchmove", move); removeEventListener("touchend", up);
        segApply(cur, false);
        if (seg.steps[cur] !== S.qty) selectQty(seg.steps[cur]);
      };
      addEventListener("pointermove", move, { passive: false }); addEventListener("pointerup", up);
      addEventListener("touchmove", move, { passive: false }); addEventListener("touchend", up);
    });
    track.addEventListener("keydown", function (e) {
      var seg = row.__ptSeg; if (!seg) return;
      var idx = Math.max(0, seg.steps.indexOf(S.qty)); var t = null;
      if (e.key === "ArrowLeft" || e.key === "ArrowUp") t = Math.max(0, idx - 1);
      else if (e.key === "ArrowRight" || e.key === "ArrowDown") t = Math.min(seg.N - 1, idx + 1);
      else if (e.key === "Home") t = 0;
      else if (e.key === "End") t = seg.N - 1;
      if (t === null) return;
      e.preventDefault();
      if (t !== idx) { selectQty(seg.steps[t]); seg.btns[t].focus(); }
    });
  }
  function drawQty() {
    var row = $("pt-qtyrow"); if (!row) return;
    /* Kit switches re-enter here with the widget already built. The steps
       never change at runtime, so refresh the numbers IN PLACE - a rebuild
       tore down the pill and track mid-frame and read as a flash (owner
       2026-08-19). Editor re-renders hand us a fresh row with no __ptSeg,
       so they still take the build path below. */
    var seg = row.__ptSeg;
    if (seg && row.contains(seg.track)) {
      seg.lblEls.forEach(function (l, i) { l.textContent = segLabelTxt(seg.steps[i]); });
      segApply(Math.max(0, seg.steps.indexOf(S.qty)), false);
      return;
    }
    row.innerHTML = "";
    var badges = {}; badges[D.badgeQty1 || 2] = D.badgeTxt1 || ""; badges[D.badgeQty2 || 4] = D.badgeTxt2 || "";
    /* Quantity steps follow the tier ladder rather than a hardcoded 1-4.
       A tier at 7 is unreachable if the page only ever offers up to 4, so the
       thresholds themselves decide what a shopper can pick. Always starts at 1
       (buying one is not a tier) and de-duplicates in case a ladder repeats. */
    var steps = [1];
    (D.tiers || []).forEach(function (t) {
      var n = Number(t.minQty);
      if (n > 1 && steps.indexOf(n) === -1) steps.push(n);
    });
    steps.sort(function (a, b) { return a - b; });
    if (steps.length === 1) steps = [1, 2, 3, 4];   /* unconfigured: keep the familiar row */
    var N = steps.length;
    /* pill position via left in container-relative calc, NOT translateX of the
       pill's own width - the elevated pill's border makes self-width % math
       overshoot the last cell (designer hit this in the reference) */
    var cell = "((100% - " + (8 + (N - 1) * 4) + "px)/" + N + ")";
    var track = document.createElement("div");
    track.className = "pt-seg"; track.setAttribute("role", "radiogroup");
    track.setAttribute("aria-label", D.lblQty || "Quantity");
    track.style.gridTemplateColumns = "repeat(" + N + ",1fr)";
    var pill = document.createElement("div");
    pill.className = "pt-seg-pill"; pill.setAttribute("aria-hidden", "true");
    pill.style.width = "calc(" + cell + ")";
    track.appendChild(pill);
    var btns = [], lblEls = [];
    steps.forEach(function (n) {
      var b = document.createElement("button"); b.type = "button";
      b.setAttribute("role", "radio");
      b.textContent = n + "\u00d7";
      b.addEventListener("click", function () { selectQty(n); });
      track.appendChild(b); btns.push(b);
    });
    var meter = document.createElement("div"); meter.className = "pt-seg-meter"; meter.setAttribute("aria-hidden", "true");
    var fill = document.createElement("div"); fill.className = "pt-seg-fill"; meter.appendChild(fill);
    var lbls = document.createElement("div"); lbls.className = "pt-seg-lbls"; lbls.setAttribute("aria-hidden", "true");
    lbls.style.gridTemplateColumns = "repeat(" + N + ",1fr)";
    steps.forEach(function (n) {
      var l = document.createElement("div");
      l.textContent = segLabelTxt(n);
      lbls.appendChild(l); lblEls.push(l);
    });
    var cap = document.createElement("div"); cap.className = "pt-seg-cap";
    var capL = document.createElement("span"); capL.className = "pt-seg-capl";
    /* the saving and the stamp are PERSISTENT children: the stamp animates in
       and out via a class toggle, which an innerHTML rebuild would destroy */
    var capSaveEl = document.createElement("span");
    var capTagEl = document.createElement("span"); capTagEl.className = "pt-seg-captag";
    /* stamp trails the Save text (owner preferred the pairing) — only its
       zoom anchor is centred, so it blooms in place instead of growing
       rightward off its left edge (owner 2026-08-19). */
    capL.appendChild(capSaveEl); capL.appendChild(capTagEl);
    var capR = document.createElement("span"); capR.className = "pt-seg-capr";
    cap.appendChild(capL); cap.appendChild(capR);
    /* With no tier ladder configured there is nothing to measure or label: the
       meter sat part-filled against no threshold and every label fell back to
       an em-dash, which read as a row of broken values rather than "no offer".
       The quantity picker itself stays — choosing 2 and giving each its own
       colour is still worth doing. Products that have tiers are unaffected. */
    var hasTiers = (D.tiers || []).length > 0;
    row.appendChild(track);
    if (hasTiers) { row.appendChild(meter); row.appendChild(lbls); }
    row.appendChild(cap);
    row.__ptSeg = { steps: steps, N: N, cell: cell, track: track, pill: pill, fill: fill, btns: btns, lblEls: lblEls, capL: capL, capSaveEl: capSaveEl, capTagEl: capTagEl, capR: capR, badges: badges };
    bindSegDrag(track, row);
    segApply(Math.max(0, steps.indexOf(S.qty)), false);
  }
  /* The per-unit drawer used to snap: going 1x -> 2x dropped a ~200px block of
     controls in with no transition and shoved everything below it down the
     page, and each further step added another row just as abruptly. Measure the
     drawer before and after the rebuild and animate its own height between the
     two, so it accordions instead of jumping. The rows are already in place when
     the animation runs - only the container's height is interpolated - so no
     layout is recomputed per frame. */
  function animateUnitsHeight(box, start, opening) {
    var end = box.getBoundingClientRect().height;
    if (Math.abs(end - start) < 2) return;
    if (box.__ptAnim) box.__ptAnim.cancel();
    var cs = getComputedStyle(box);
    var from = { height: start + "px" }, to = { height: end + "px" };
    if (opening) {
      /* from nothing: fold the padding and fade in, or the drawer's own
         28px of padding would pop into place a frame before its content */
      from.paddingTop = "0px"; from.paddingBottom = "0px"; from.opacity = "0";
      to.paddingTop = cs.paddingTop; to.paddingBottom = cs.paddingBottom; to.opacity = "1";
    }
    box.style.overflow = "hidden";
    var a = box.animate([from, to], { duration: 300, easing: "cubic-bezier(.4,0,.2,1)" });
    box.__ptAnim = a;
    /* A backgrounded tab pauses animations, so onfinish alone is not a
       guarantee that the drawer ever gets its overflow back. Settle the end
       state on a timer as well; whichever arrives first wins and the other
       is a harmless no-op. */
    var settle = function () { box.style.overflow = ""; if (box.__ptAnim === a) box.__ptAnim = null; };
    a.onfinish = a.oncancel = settle;
    setTimeout(settle, 600);
  }
  var uadvT = null;   /* pending auto-advance; any other interaction cancels it */
  function renderUnits() {
    var box = $("pt-units"), rows = $("pt-unitrows"); if (!box || !rows) return;
    var wasOpen = box.style.display === "block";
    var start = box.getBoundingClientRect().height;
    if (S.qty < 2) {
      hideBump();
      if (!wasOpen || reduced) { box.style.display = "none"; return; }
      if (box.__ptAnim) box.__ptAnim.cancel();
      var cs0 = getComputedStyle(box);
      box.style.overflow = "hidden";
      var a = box.animate(
        [{ height: start + "px", paddingTop: cs0.paddingTop, paddingBottom: cs0.paddingBottom, opacity: 1 },
         { height: "0px", paddingTop: "0px", paddingBottom: "0px", opacity: 0 }],
        { duration: 260, easing: "cubic-bezier(.4,0,.2,1)" });
      box.__ptAnim = a;
      /* Same guard as the open animation: never leave the drawer half-collapsed
         with its overflow clipped because the tab was in the background. */
      var hide = function () {
        if (S.qty >= 2) return;              /* the shopper went back up mid-collapse */
        box.style.display = "none"; box.style.overflow = "";
        if (box.__ptAnim === a) box.__ptAnim = null;
      };
      a.onfinish = a.oncancel = hide;
      setTimeout(hide, 560);
      return;
    }
    box.style.display = "block";
    /* ---- guided accordion (spec-per-tripod-config-2b, 2026-08-20) ------
       Receipt rows, one open at a time. "Touched" is bookkeeping for the
       progress bar and dashed pending dots ONLY — every unit carries a
       valid default, so add-to-cart never waits on this UI.
       ARCHITECTURE (motion audit, owner 2026-08-20): rows are built ONCE
       per row count and every state change applies IN PLACE — same rule
       as the quantity selector. Fold/unfold is a CSS grid-rows transition
       on persistent bodies, so the closing panel folds while the opening
       one unfolds and nothing ever pops out of existence. */
    if (!rows.__ptU || rows.__ptU.length !== S.qty) buildUnitRows(rows);
    applyUnits(rows);
    /* the box-level animation covers the drawer appearing and qty changes;
       open/close of rows is carried by the bodies' own CSS transition (at
       this point in the frame their heights haven't moved yet, so this
       measures a ~zero diff and no-ops for those) */
    if (!reduced) animateUnitsHeight(box, start, !wasOpen);
  }
  function uswHtml(c) {
    return c && c.swatch ? '<img src="' + esc(c.swatch) + '" alt="">'
      : '<span class="pt-swf" style="background:' + safeHex(c ? c.hex : "#ccc") + '"></span>';
  }
  function ucolorObj(name) {
    var o = null;
    (D.colors || []).some(function (c) { if (c.name === name) { o = c; return true; } return false; });
    return o;
  }
  function buildUnitRows(rows) {
    rows.innerHTML = "";
    rows.__ptU = [];
    S.units.forEach(function (u, ui) {
      var row = document.createElement("div"); row.className = "pt-urow2";
      var btn = document.createElement("button"); btn.type = "button"; btn.className = "pt-urbtn";
      var dot = document.createElement("span");
      var txt = document.createElement("span"); txt.className = "pt-utxt";
      var ttl = document.createElement("span"); ttl.className = "pt-utitle";
      /* always "Tripod N" — the remote half of a bundle is identical per
         unit, so renaming rows to "Bundle N" added nothing (owner 2026-08-20) */
      ttl.textContent = (D.txtTripod || "Tripod") + " " + (ui + 1);
      var sum = document.createElement("span"); sum.className = "pt-usum";
      txt.appendChild(ttl); txt.appendChild(sum);
      /* the check badge is persistent and class-toggled so it can settle in
         like the qty stamp; drawn SVG stroke, not a text glyph (spec) */
      var chk = document.createElement("span"); chk.className = "pt-uchk";
      chk.setAttribute("role", "img"); chk.setAttribute("aria-label", D.txtConfigured || "configured");
      chk.innerHTML = '<svg width="9" height="8" viewBox="0 0 9 8" aria-hidden="true"><path d="M1 4.2 L3.4 6.6 L8 1.4" fill="none" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      var chev = document.createElement("span"); chev.className = "pt-uchev"; chev.setAttribute("aria-hidden", "true");
      chev.textContent = "⌄";
      btn.appendChild(dot); btn.appendChild(txt); btn.appendChild(chk); btn.appendChild(chev);
      btn.addEventListener("click", function () {
        clearTimeout(uadvT);
        S.uopen = S.uopen === ui ? -1 : ui;
        applyUnits(rows);
      });
      row.appendChild(btn);
      var bwrap = document.createElement("div"); bwrap.className = "pt-ubwrap";
      var body = document.createElement("div"); body.className = "pt-ubody";
      var bin = document.createElement("div"); bin.className = "pt-ubin";
      var seg = document.createElement("div"); seg.className = "pt-useg";
      var segBtns = [];
      /* The fits offered are whatever the variants actually carry, not the two
         labels in the settings. A product sold in a single fit — the 2024 kit —
         used to get a toggle offering "Slim Fit" it has no variant for. On a
         two-fit product this is the same two buttons as before. */
      var fitList = [];
      (D.variants || []).forEach(function (v) {
        if (v.fit && fitList.indexOf(v.fit) < 0) fitList.push(v.fit);
      });
      if (fitList.length < 2) fitList = [];      /* one fit: nothing to choose */
      fitList.forEach(function (fl) {
        var b = document.createElement("button"); b.type = "button"; b.textContent = fl;
        b.__fit = fl;
        b.addEventListener("click", function () {
          clearTimeout(uadvT);
          var u2 = S.units[ui]; if (!u2) return;
          u2.fit = fl; u2.touched = true;   /* fit taps never auto-advance */
          applyUnits(rows); sync();
        });
        seg.appendChild(b); segBtns.push(b);
      });
      var clbl = document.createElement("div"); clbl.className = "pt-uclbl";
      var clb = document.createElement("b"); clb.textContent = D.txtColorWord || "Color";
      var cname = document.createElement("span");
      clbl.appendChild(clb); clbl.appendChild(cname);
      var swr = document.createElement("div"); swr.className = "pt-usw2";
      var all = document.createElement("button"); all.type = "button"; all.className = "pt-uall";
      var words = (D.txtAllWords || "both,all three,all four").split(",");
      var word = (words[S.qty - 2] || "all " + S.qty).trim();
      all.textContent = (D.txtApplyAll || "Make {all} like this").replace("{all}", word);
      all.addEventListener("click", function () {
        clearTimeout(uadvT);
        var u2 = S.units[ui]; if (!u2) return;
        var f = u2.fit, c = u2.color;
        S.units.forEach(function (x) { x.fit = f; x.color = c; x.touched = true; x.picked = true; });
        S.uopen = -1;
        applyUnits(rows); sync();
      });
      if (segBtns.length) bin.appendChild(seg);
      bin.appendChild(clbl); bin.appendChild(swr); bin.appendChild(all);
      body.appendChild(bin); bwrap.appendChild(body); row.appendChild(bwrap);
      rows.appendChild(row);
      rows.__ptU.push({ row: row, btn: btn, dot: dot, sum: sum, chk: chk, segBtns: segBtns, cname: cname, swr: swr, dotKey: null, swFit: null });
    });
  }
  function fillUnitSwatches(rows, R, ui) {
    var u = S.units[ui]; if (!u) return;
    R.swFit = u.fit;
    R.swr.innerHTML = "";
    colorsFor(u.fit).forEach(function (c) {
      var b = document.createElement("button"); b.type = "button"; b.title = c.name;
      b.setAttribute("aria-label", c.name);
      b.innerHTML = uswHtml(c);
      b.addEventListener("click", function () {
        var u2 = S.units[ui]; if (!u2) return;
        u2.color = c.name; u2.touched = true; u2.picked = true;
        applyUnits(rows); sync();
        /* auto-advance: settle, then glide open the first unit still pending */
        clearTimeout(uadvT);
        uadvT = setTimeout(function () {
          if (S.qty < 2) return;
          var nxt = -1;
          S.units.some(function (x, j) { if (!x.touched) { nxt = j; return true; } return false; });
          S.uopen = nxt;
          applyUnits(rows);
        }, 500);
      });
      R.swr.appendChild(b);
    });
  }
  function applyUnits(rows) {
    var refs = rows.__ptU || [];
    var touchedN = 0;
    S.units.forEach(function (x) { if (x.touched) touchedN++; });
    var cnt = $("pt-ucount");
    if (cnt) cnt.textContent = (D.txtUnitsChosen || "{n} of {q} chosen").replace("{n}", touchedN).replace("{q}", S.qty);
    var bar = $("pt-ubar"), fillBar = $("pt-ubarf");
    if (bar) { bar.setAttribute("aria-valuenow", touchedN); bar.setAttribute("aria-valuemax", S.qty); }
    if (fillBar) fillBar.style.width = (touchedN / S.qty * 100) + "%";
    refs.forEach(function (R, ui) {
      var u = S.units[ui]; if (!u) return;
      if (!selectable(u.fit, u.color)) { var alt = colorsFor(u.fit)[0]; if (alt) u.color = alt.name; }
      var open = S.uopen === ui;
      /* NOTHING shows as chosen until an explicit colour pick (owner
         2026-08-20): the unit still CARRIES its valid default underneath —
         cart and prices use it, ATC stays live — but the dot stays dashed,
         no swatch wears the ring and the name stays blank until `picked`. */
      var known = !!u.picked;
      R.row.classList.toggle("pt-open", open);
      R.btn.setAttribute("aria-expanded", open ? "true" : "false");
      var dotKey = known ? "c:" + u.color : "pending";
      if (R.dotKey !== dotKey) {
        R.dotKey = dotKey;
        R.dot.className = known ? "pt-udot" : "pt-updot";
        R.dot.innerHTML = known ? uswHtml(ucolorObj(u.color)) : "";
      }
      R.sum.textContent = known ? u.fit + " · " + u.color : (D.txtUnitTap || "Tap to choose fit & color");
      R.sum.classList.toggle("pt-dim", !known);
      R.chk.classList.toggle("pt-on", !!u.touched);
      R.segBtns.forEach(function (b) { b.classList.toggle("pt-sel", b.__fit === u.fit); });
      /* nbsp, not empty: an empty span contributes no line box, so the label
         row grew ~3px the moment a name arrived (owner-spotted shift) */
      R.cname.textContent = known ? u.color : " ";
      if (R.swFit !== u.fit) fillUnitSwatches(rows, R, ui);
      [].forEach.call(R.swr.children, function (b) { b.classList.toggle("pt-sel", known && b.title === u.color); });
    });
    if (bumpUnpicked() === 0) hideBump();   /* the question answered itself */
  }

  /* Spread the boxes across whatever width the container actually has, using a
     fraction of the MEASURED image width. Fixed pixel margins cannot work here:
     the image is ~74px wide on desktop and ~44px on a phone, so one margin value
     is either barely an overlap or steps backwards and stacks them on top of one
     another. Remotes are all the same box, so they sit tighter (K) than the
     tripod boxes - the count has to read, the faces do not. */
  function layoutPkg(prev, scope) {
    /* Scoped to one row: during a crossfade the outgoing row is still in the
       DOM, and measuring both at once produced nonsense overlap. Callers
       without a scope (resize, same-signature refresh) now default to the
       NEWEST row for the same reason — unscoped, a refresh landing mid-fade
       counted both lineups as one and shoved the visible row off-centre
       (owner spotted it at 3x/4x bundles, 2026-08-20). */
    if (!scope) {
      var rowsAll = prev.querySelectorAll(".pt-pkgrow");
      scope = rowsAll.length ? rowsAll[rowsAll.length - 1] : prev;
    }
    var imgs = [].slice.call(scope.querySelectorAll("img"));
    if (!imgs.length) return;
    var w = imgs[0].getBoundingClientRect().width;
    if (!w) return;                      /* not decoded yet; the load handler retries */
    var cs = getComputedStyle(prev);
    var avail = prev.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    var K = 0.62;                        /* remote step, as a share of the tripod step */
    var nr = imgs.filter(function (i) { return i.classList.contains("pt-pkgr"); }).length;
    var nt = imgs.length - nr;
    var denom = (nt - 1) + nr * K;
    var step = denom > 0 ? (avail - w) / denom : 0;
    step = Math.max(0.30 * w, Math.min(0.8 * w, step));   /* always legible, never gapped */
    /* ...but never wider than the panel: when the legibility floor would
       push the lineup past the available width, fitting wins over spacing */
    if (denom > 0) step = Math.min(step, (avail - w) / denom);
    var span = w;
    imgs.forEach(function (im, i) {
      if (i === 0) { im.style.marginLeft = "0px"; return; }
      var s = im.classList.contains("pt-pkgr") ? step * K : step;
      im.style.marginLeft = (s - w) + "px";
      span += s;
    });
    /* Set the row's width to the span we just computed. Shrink-to-fit does not
       agree with the visual span once negative margins accumulate, which left
       the row sitting ~30px off-centre and clipping on the left. */
    var row = (scope && scope.classList.contains("pt-pkgrow")) ? scope : prev.querySelector(".pt-pkgrow");
    if (row) row.style.width = Math.ceil(span) + "px";
  }

  /* ----- composed "what arrives" preview ----- */
  function updatePkg() {
    var prev = $("pt-pkgprev"), line = $("pt-pkgline");
    if (line) {
      var counts = {};
      S.units.slice(0, S.qty).forEach(function (u) {
        var k = u.color + ", " + u.fit; counts[k] = (counts[k] || 0) + 1;
      });
      var parts = Object.keys(counts).map(function (k) { return counts[k] + "× " + (D.txtTripodBox || "Tripod box") + " (" + k + ")"; });
      if (S.kit === 1) parts.push(S.qty + "× " + (D.txtRemoteBox || "Remote box"));
      /* The price for exactly what the boxes above show, against the same
         reference as every other price on the page. */
      var pTot = tierTotal(S.qty), pRef = S.qty * unitRefCents();
      line.innerHTML = "<span>" + (D.txtArrives || "Arriving") + ":</span> " + parts.join("  +  ") +
        '<div class="pt-pkgtot">' + money(pTot) +
        (pRef > pTot ? "<s>" + money(pRef) + "</s>" : "") + "</div>";
    }
    if (prev) {
      /* Decode BEFORE swapping, like the gallery hero does. Rebuilding the row
         with fresh <img> elements meant every box measured 0 until it decoded,
         so the row collapsed and the boxes visibly jumped on every colour or
         fit change. The current row now stays untouched until the new renders
         are decoded, then swaps in one frame. */
      var want = [];
      var shown = 0;
      S.units.slice(0, S.qty).forEach(function (u) {
        if (shown >= 4) return;
        var c = D.colors.find(function (x) { return x.name === u.color; });
        var img = c ? (u.fit === D.fitSlim ? (c.boxSlim || c.boxStd) : c.boxStd) : null;
        if (img) { want.push({ src: img, alt: u.color, cls: "" }); shown++; }
      });
      if (S.kit === 1 && D.remote && D.remote.boxImage) {
        for (var i = 0; i < Math.min(S.qty, 4); i++) {
          want.push({ src: D.remote.boxImage, alt: D.remote.title, cls: "pt-pkgr" });
        }
      }

      /* the pill does not depend on the renders, so it updates immediately */
      var oldPill = prev.querySelector(".pt-pkgsave");
      if (oldPill) oldPill.remove();
      var mode = D.pkgSaveMode || "bundle";
      if (mode !== "off") {
        var earned = S.qty * unitRefCents() - tierTotal(S.qty);
        var pill = null;
        if (earned > 0) {
          pill = document.createElement("div");
          pill.className = "pt-pkgsave";
          /* Its own label, not the shared one. This badge describes the order
             already composed beside it, so it reads as a statement ("Saving
             $14.20"); the buttons elsewhere are still things to click, where
             the imperative is right. */
          pill.innerHTML = esc(D.txtPkgSave || "Saving") + " " + money(earned);   /* money() emits the shop money_format markup */
        } else if (mode === "prompt") {
          var next = 2 * unitRefCents() - tierTotal(2);
          if (next > 0) {
            pill = document.createElement("div");
            pill.className = "pt-pkgsave pt-hint";
            pill.innerHTML = esc(D.txtPkgSingle || "2 for {amount} less").replace("{amount}", money(next));
          }
        }
        if (pill) prev.appendChild(pill);
      }

      if (!want.length) {
        prev.innerHTML = '<div class="pt-ph">' + esc(D.txtPkgPlaceholder || "Box renders render here once uploaded in the theme editor") + "</div>";
      } else {
        var sig = want.map(function (x) { return x.cls + "|" + x.src; }).join(",");
        if (prev.__ptSig === sig) {
          /* same selection: either already drawn, or a decode is in flight.
             Re-entering here would bump the token and cancel that in-flight
             swap, and since sync() calls this more than once the row would
             never land at all. */
          if (prev.querySelector(".pt-pkgrow")) layoutPkg(prev);
        } else {
          prev.__ptSig = sig;
          var token = (prev.__ptTok = (prev.__ptTok || 0) + 1);
          /* Readiness via load/error plus an explicit cached check, NOT decode().
             decode() was observed never settling on an image that had already
             loaded (complete=true, naturalWidth=1133), which left the preview
             permanently empty. The timeout guarantees the swap always happens
             even if an image never resolves either way. */
          var loaded = want.map(function (x) {
            return new Promise(function (res) {
              var done = false;
              var fin = function () { if (!done) { done = true; res(); } };
              var im = new Image();
              im.onload = fin;
              im.onerror = fin;
              im.src = x.src;
              if (im.complete && im.naturalWidth) fin();     /* already cached */
              setTimeout(fin, 1500);                          /* never hang the panel */
            });
          });
          Promise.all(loaded).then(function () {
            if (prev.__ptTok !== token) return;          /* a newer selection won */
            /* ALL previous rows, not just the first. querySelector picked one,
               so changing quantity twice in quick succession re-targeted the
               row already being removed and stranded the one in between — it
               stayed forever as a second grid row, stacked diagonally under
               the real one (owner spotted it, 2026-08-01). */
            var oldRows = [].slice.call(prev.querySelectorAll(".pt-pkgrow"));
            var ph = prev.querySelector(".pt-ph"); if (ph) ph.remove();
            var row = document.createElement("div");
            row.className = "pt-pkgrow";
            want.forEach(function (x) {
              var el = document.createElement("img");
              el.src = x.src; el.alt = x.alt;            /* property assignment: no HTML parsing */
              if (x.cls) el.className = x.cls;
              row.appendChild(el);
            });
            prev.appendChild(row);                        /* attach, then measure */
            prev.classList.toggle("pt-pkgdense", want.length > 5);
            layoutPkg(prev, row);
            /* Crossfade rather than cut. Adding or dropping the remote used to
               swap the whole lineup in one frame, which read as a flinch even
               though nothing was loading by then. Both rows share one grid cell
               so the outgoing one fades in place instead of shifting the new
               one. */
            /* Sweep by identity rather than by reference: whatever is in the
               panel that is not the row we just built has been superseded, so
               a swap that overtakes an earlier one still cleans up after it. */
            var drop = function () {
              /* Only the swap that still owns the panel may sweep. Each swap
                 closes over its own row, so without this a stale timeout from
                 an overtaken swap would delete the newer, correct row and
                 leave the panel empty. The winning swap sweeps everything. */
              if (prev.__ptTok !== token) return;
              [].slice.call(prev.querySelectorAll(".pt-pkgrow")).forEach(function (r) {
                if (r !== row && r.parentNode) r.remove();
              });
              row.style.gridArea = "";                    /* back to normal centring */
            };
            if (oldRows.length && !reduced) {
              row.style.gridArea = "1 / 1";
              row.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 240, easing: "ease-out" });
              oldRows.forEach(function (r) {
                r.style.gridArea = "1 / 1";
                var out = r.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200, easing: "ease-in" });
                out.onfinish = out.oncancel = drop;
              });
              setTimeout(drop, 500);                      /* a paused tab must not strand rows */
            } else {
              drop();
            }
          });
        }
      }
    }
  }

  /* ----- totals + sync ----- */
  function unitLabel() {
    var us = S.units.slice(0, S.qty);
    var fits = {}, cols = {};
    us.forEach(function (u) { fits[u.fit] = 1; cols[u.color] = 1; });
    var cfg = (Object.keys(fits).length === 1 ? us[0].fit : (D.txtMixedFits || "Mixed fits")) + ", " +
              (Object.keys(cols).length === 1 ? us[0].color : (D.txtMixedColors || "mixed colors"));
    if (S.qty < 2) return (S.kit === 1 ? (D.txtWithRemote || "Tripod with Remote") + ", " : "") + cfg;
    return S.qty + " " + (S.kit === 1 ? (D.txtBundles || "bundles") : (D.txtTripods || "tripods")) + ", " + cfg;
  }
  function sync() {
    var total = tierTotal(S.qty);
    var compare = S.qty * unitRefCents();
    var set = function (id, html) { var el = $(id); if (el) el.innerHTML = html; };
    set("pt-ip", money(total) + (compare > total ? " <s>" + money(compare) + "</s>" : ""));
    /* The sticky bar keeps the plain total. Its label sits under the price in
       a narrow fixed-height strip, so a struck reference wrapped onto its own
       line and broke the bar's layout (owner, 2026-08-01). */
    set("pt-sprice", money(total));
    set("pt-slbl", esc(unitLabel()));
    /* (v2) final CTA mirrors the live selection total + what it covers */
    set("pt-fp2", money(total) + (compare > total ? " <s>" + money(compare) + "</s>" : ""));
    var fd = $("pt-finald");
    if (fd) fd.textContent = (D.txtIncludes || "Includes") + " " + S.qty + " " +
      (S.qty > 1 ? (D.txtTripods || "tripods") : (D.txtTripod || "Tripod")) +
      (S.kit === 1 ? " + " + S.qty + " " + (S.qty > 1 ? (D.txtRemotes || "Remotes") : (D.txtRemoteWord || "Remote")) : "");
    var atcTxt = S.qty > 1
      ? (D.txtAddN || "Add {n} to cart").replace("{n}", S.qty + (S.kit === 1 ? " " + (D.txtBundles || "bundles") : ""))
      : (S.kit === 1 ? (D.txtAddBundle || "Add bundle to cart") : (D.txtAdd || "Add to cart"));
    set("pt-iatctxt", esc(atcTxt));
    var hint = $("pt-qtyhint");
    if (hint) hint.textContent = S.kit === 1 ? (D.txtMultiBundles || "multi-buy savings, full bundles") : (D.txtMulti || "multi-buy savings");
    // kit card prices from live data
    var t0 = tripodUnitCents(), t0ref = tripodRefCents();
    set("pt-kp0", money(t0) + (t0ref > t0 ? "<s>" + money(t0ref) + "</s>" : ""));
    if (D.remote) {
      var bCents = tripodUnitCents() + remotePairCents();
      var bComp = bundleRefCents();
      set("pt-kp1", money(bCents) + (bComp > bCents ? "<s>" + money(bComp) + "</s>" : ""));
      var off = $("pt-koff");
      if (off) {
        off.innerHTML = bComp > bCents ? esc(D.txtSave || "Save") + " " + money(bComp - bCents) : "";
        off.style.display = bComp > bCents ? "" : "none";
      }
      /* bundle teaser (spec 1c): live saving in the label. It STAYS visible
         when the bundle is selected — hiding it reflowed the page under the
         shopper's finger (owner 2026-08-20); only a zero saving hides it. */
      var bt = $("pt-bteaser");
      if (bt) {
        var tsave = bComp - bCents;
        bt.hidden = tsave <= 0;
        set("pt-btsave", esc(D.txtTeaser || "Bundle & save {amount}").replace("{amount}", money(tsave)));
      }
    }
    // dynamic payment button: only representable as ONE variant purchase
    var pf = $("pt-payform");
    if (pf) {
      var v = variantFor(S.fit, S.color);
      var single = S.kit === 0 && v && (S.qty === 1 || S.units.slice(0, S.qty).every(function (u) { return u.fit === S.fit && u.color === S.color; }));
      // collapse smoothly instead of display:none so the page doesn't jump
      pf.classList.toggle("pt-payoff", !single);
      if (single && v) {
        var idInput = pf.querySelector('input[name="id"]'); if (idInput) idInput.value = v.id;
        var qInput = pf.querySelector('input[name="quantity"]'); if (qInput) qInput.value = S.qty;
      }
    }
    /* Region with no stock: say so on the button instead of offering a purchase
       that the cart will refuse. The price stays real — a shopper deciding
       whether to wait still wants to know what it costs. */
    var vSel = variantFor(S.fit, S.color);
    var oos = !vSel || !vSel.available;
    var atcBtn = $("pt-iatc");
    var stickyBtn = $("pt-satc") ? $("pt-satc").querySelector("button") : null;
    [atcBtn, stickyBtn].forEach(function (b) {
      if (!b) return;
      b.disabled = oos;
      b.setAttribute("aria-disabled", oos ? "true" : "false");
    });
    if (oos) set("pt-iatctxt", esc(D.txtSoldOutRegion || "Unavailable in your region"));
    document.documentElement.classList.toggle("pt-oos", oos);

    updatePkg();
  }

  /* ----- delivery date (cutoff + business days) ----- */
  function renderDelDate() {
    var el = $("pt-deldate"); if (!el) return;
    var days = D.shipDays || 5;
    try {
      /* hourCycle h23, NOT hour12:false — some engines render midnight as
         "24" with hour12:false, which would add a bogus day at 12-1 AM ET */
      var etHour = parseInt(new Intl.DateTimeFormat("en-US", { hour: "numeric", hourCycle: "h23", timeZone: "America/New_York" }).format(new Date()), 10);
      if (etHour >= (D.cutoffHour || 14)) days += 1;
    } catch (e) { /* keep default */ }
    var d = new Date(), add = days;
    while (add > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) add--; }
    el.textContent = d.toLocaleDateString(D.locale || "en-US", { weekday: "short", month: "short", day: "numeric" });
  }

  /* ----- add to cart: real /cart/add.js, theme drawer opens ----- */
  function cartItems() {
    var counts = {};
    S.units.slice(0, S.qty).forEach(function (u) {
      var v = variantFor(u.fit, u.color); if (!v) return;
      counts[v.id] = (counts[v.id] || 0) + 1;
    });
    var items = Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
    if (S.kit === 1 && D.remote) items.push({ id: D.remote.variantId, quantity: S.qty });
    return items;
  }
  /* ---- soft speed bump (owner 2026-08-20, exploring) --------------------
     ATC stays LIVE (spec: progress is never a gate). But when multi-buy
     units still have no explicitly picked colour, the FIRST tap unfolds a
     small confirm above the button: proceed with the defaults, or jump to
     the configurator. A second tap on the buy button also proceeds. */
  function bumpUnpicked() {
    var n = 0;
    if (S.qty >= 2) S.units.forEach(function (x) { if (!x.picked) n++; });
    return n;
  }
  function bumpEl() {
    var ex = $("pt-bump"); if (ex) return ex;
    var atc = $("pt-iatc"); if (!atc || !atc.parentNode) return null;
    var w = document.createElement("div"); w.id = "pt-bump"; w.className = "pt-bump";
    w.innerHTML = '<div class="pt-bump-in"><div class="pt-bump-box"><div class="pt-bump-msg" id="pt-bump-msg"></div><div class="pt-bump-btns"><button type="button" class="pt-bump-go" id="pt-bump-go"></button><button type="button" class="pt-bump-pick" id="pt-bump-pick"></button></div></div></div>';
    var anchor = atc.closest(".pt-atcwrap") || atc;
    anchor.parentNode.insertBefore(w, anchor);
    $("pt-bump-go").addEventListener("click", function () {
      hideBump();
      window.ptAddToCart($("pt-iatc"), true);
    });
    $("pt-bump-pick").addEventListener("click", function () {
      hideBump();
      var nxt = -1;
      S.units.some(function (x, j) { if (!x.picked) { nxt = j; return true; } return false; });
      S.uopen = nxt;
      var rowsEl = $("pt-unitrows"); if (rowsEl) applyUnits(rowsEl);
      var box = $("pt-units");
      if (box) { try { box.scrollIntoView({ behavior: "smooth", block: "center" }); } catch (e) { box.scrollIntoView(); } }
    });
    return w;
  }
  function showBump(n) {
    var w = bumpEl(); if (!w) return false;
    /* name the actual defaults they'd get (first unconfigured unit's) */
    var fu = null;
    S.units.some(function (x) { if (!x.picked) { fu = x; return true; } return false; });
    $("pt-bump-msg").textContent = (D.txtBumpMsg || "{n} of your {q} tripods have no color or fit picked. Add anyway will default them to {fit} · {color}.")
      .replace("{n}", n).replace("{q}", S.qty)
      .replace("{fit}", fu ? fu.fit : S.fit).replace("{color}", fu ? fu.color : S.color);
    $("pt-bump-go").textContent = D.txtBumpGo || "Add anyway";
    $("pt-bump-pick").textContent = D.txtBumpPick || "Choose colors";
    w.classList.add("pt-on");
    var atcEl = $("pt-iatc");
    var sc = atcEl && atcEl.closest(".pt-scope");   /* the BUY BOX's scope — every section has one */
    if (sc) sc.classList.add("pt-bumping");   /* the card takes the button's place */
    var atc = $("pt-iatc");
    if (atc) {
      var r = atc.getBoundingClientRect();
      if (r.top < 0 || r.bottom > window.innerHeight) {
        try { atc.scrollIntoView({ behavior: "smooth", block: "center" }); } catch (e) { /* stay put */ }
      }
    }
    return true;
  }
  function hideBump() {
    var w = $("pt-bump"); if (w) w.classList.remove("pt-on");
    var atcEl = $("pt-iatc");
    var sc = atcEl && atcEl.closest(".pt-scope");
    if (sc) sc.classList.remove("pt-bumping");
  }

  window.ptAddToCart = function (btn, force) {
    if (!force && D.bumpEnabled !== false && bumpUnpicked() > 0) {
      var bw = $("pt-bump");
      var visible = bw && bw.classList.contains("pt-on");
      if (!visible) { if (showBump(bumpUnpicked())) return; }
      hideBump();   /* second tap while the bump shows = they saw it, proceed */
    } else hideBump();
    var items = cartItems();
    if (!items.length) { toast(esc(D.txtUnavailable || "Selection unavailable")); return; }
    /* disable BOTH add buttons (inline + sticky bar) while the request is in
       flight — disabling only the tapped one left the other live, and a fast
       second tap added the items twice */
    var btns = [];
    document.querySelectorAll("#pt-iatc, #pt-satc button").forEach(function (b) { btns.push(b); });
    if (btn && btns.indexOf(btn) === -1) btns.push(btn);
    /* the tapped button greys out and shrinks (site pressed language) and
       HOLDS it while the request runs and, when the flow goes to the cart
       page, until that page arrives (owner: a click must never be followed by
       nothing); re-enabled only when we stay on this page */
    var leaving = false;
    btns.forEach(function (b) { b.disabled = true; b.classList.add("pt-busy"); });
    fetch((D.routesCartAdd || "/cart/add.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || "Could not add to cart"); });
      return r.json();
    }).then(function () {
      // matcher context rides along as cart attributes (order attributes
      // downstream: revenue-per-phone, support triage). pt_fit reflects the
      // fit actually in the cart, even after a manual override.
      var attrsDone = Promise.resolve();
      if (S.match) {
        attrsDone = fetch(D.routesCartUpdate || "/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ attributes: {
            pt_phone_id: S.match.id,
            pt_fit: (S.fit === D.fitSlim) ? "slim" : "standard",
            pt_case_answer: S.match.caseAnswer || ""
          } })
        }).catch(function () { /* attributes are best-effort */ });
      }
      // let the theme know: refresh count + try common drawer events
      fetch(D.routesCart || "/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll("[data-cart-count], .cart-count, .cart-count-bubble span").forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent("theme:cart:change", { bubbles: true, detail: { cart: cart } }));
      });
      /* wait for the attributes write before leaving the page — a bare
         redirect aborts the in-flight request and silently drops the
         phone-match order attributes (audit fix) */
      if (D.afterAdd === "cart") { leaving = true; attrsDone.then(function () { window.location.href = "/cart"; }); return; }
      toast(esc(D.txtAdded || "Added to cart") + ' · <a href="/cart" style="text-decoration:underline;color:inherit">' + esc(D.txtViewCart || "View cart") + "</a>");
    }).catch(function (e) {
      toast(esc(e.message || "Could not add to cart"));
    }).finally(function () { if (!leaving) btns.forEach(function (b) { b.disabled = false; b.classList.remove("pt-busy"); }); });
  };
  /* coming back to this page from the cart (bfcache) must not show the held
     "adding" state; same for links held pressed below */
  window.addEventListener("pageshow", function (e) {
    if (!e.persisted) return;
    document.querySelectorAll(".pt-busy, .pt-pressed").forEach(function (b) { b.disabled = false; b.classList.remove("pt-busy"); b.classList.remove("pt-pressed"); });
  });
  /* every link on the PT pages that leaves the page holds the pressed state
     until the next page arrives (same as the header) */
  document.addEventListener("click", function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest(".pt-scope a[href]"); if (!a) return;
    var href = a.getAttribute("href") || "";
    if (!href || href.charAt(0) === "#" || /^(javascript|mailto|tel):/i.test(href) || a.target === "_blank") return;
    a.classList.add("pt-pressed"); setTimeout(function () { a.classList.remove("pt-pressed"); }, 4000);
  });

  /* ----- sticky ATC ----- */
  window.addEventListener("scroll", function () {
    var iatc = $("pt-iatc"); if (!iatc) return;   /* resolved per-scroll: survives editor re-renders */
    var past = iatc.getBoundingClientRect().bottom < 0;
    var s = $("pt-satc"); if (s) s.classList.toggle("pt-on", past);
    document.documentElement.classList.toggle("pt-chat-on", past);
  }, { passive: true });
  /* (v2) pill info area is tappable — scrolls back to the buy box.
     Delegated so it survives Theme Editor section re-renders. */
  document.addEventListener("click", function (e) {
    if (e.target.closest && e.target.closest("#pt-satc .pt-info")) window.ptToBuy();
  });

  /* ----- init ----- */
  // fit pills — delegated so editor re-renders don't orphan the listeners
  document.addEventListener("click", function (e) {
    if (!e.target.closest) return;
    if (e.target.closest("#pt-fp-std")) window.ptFitClick(D.fitStd);
    else if (e.target.closest("#pt-fp-slim")) window.ptFitClick(D.fitSlim);
  });
  /* Proof rail: a transform-driven marquee you can also throw around.

     Why not native scroll. scrollLeft lands on device pixels, so a drift of
     8px/second advances in visible one-pixel steps — smooth in theory, steppy
     to the eye. A transform is composited and sub-pixel, so the same speed is
     genuinely fluid. Taking the transform means taking the dragging too, which
     is what makes it behave the way anyone who has used a phone expects.

     Without JS the rail is an ordinary horizontal scroller and everything still
     works; this upgrades it in place.

     The track is two identical copies of the photo set, so position wraps by
     one set width and the pixels either side of the wrap are the same. That
     also means dragging never hits an end — it is a band going past, not a
     list with edges. */
  function initProofRails() {
    document.querySelectorAll(".pt-scope .pt-proofrail").forEach(function (rail) {
      var track = rail.querySelector(".pt-prooftrack");
      if (!track || rail.__ptRail) return;
      var originals = [].slice.call(track.children);
      if (!originals.length) return;
      rail.__ptRail = true;

      var auto = Number(rail.getAttribute("data-pt-autoscroll")) || 0;
      var pxPerSec = auto * 4;           /* 2 -> 8px/s, roughly a tile a minute */

      originals.forEach(function (el) {
        var clone = el.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        clone.querySelectorAll("img").forEach(function (i) { i.setAttribute("alt", ""); });
        track.appendChild(clone);
      });

      var setWidth = 0;
      function measure() {
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        setWidth = 0;
        originals.forEach(function (el) { setWidth += el.getBoundingClientRect().width + gap; });
      }
      measure();
      window.addEventListener("resize", measure);

      /* Lazy loading works on the viewport, and everything to the side of a
         horizontal band is outside it — so the next photo genuinely had not
         been fetched when it was dragged in, and arrived blank for a moment.
         Warm a screen's width either side of what is showing: enough that the
         neighbours are always ready, without pulling the whole set down for
         someone who never touches the band.

         Measured with getBoundingClientRect against the rail's own rect, which
         already includes the track's transform. offsetLeft was wrong here: it
         is relative to the nearest POSITIONED ancestor, and .pt-shot is
         position:relative, so the numbers were not rail-relative at all and
         the window matched nothing. */
      var lastWarm = null;
      function warm() {
        var railRect = rail.getBoundingClientRect();
        var reach = railRect.width || rail.clientWidth;
        [].slice.call(track.children).forEach(function (el) {
          var r = el.getBoundingClientRect();
          var left = r.left - railRect.left;
          if (left + r.width < -reach || left > railRect.width + reach) return;
          el.querySelectorAll("img").forEach(function (img) {
            if (img.loading === "lazy") img.loading = "eager";
            if (!img.complete) {
              /* a detached Image shares the HTTP cache, so this fills it even
                 where flipping the attribute alone does not re-trigger a fetch */
              var w = new Image();
              if (img.sizes) w.sizes = img.sizes;
              if (img.srcset) w.srcset = img.srcset;
              w.src = img.currentSrc || img.src;
            }
          });
        });
        lastWarm = pos;
      }
      /* nothing is fetched until the band is actually approaching the screen */
      if (window.IntersectionObserver) {
        var wio = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { warm(); wio.disconnect(); } });
        }, { rootMargin: "200px" });
        wio.observe(rail);
      } else {
        warm();
      }

      rail.classList.add("pt-drag");
      rail.tabIndex = 0;

      var pos = 0, paused = false, dragging = false, vel = 0, last = 0;
      var startX = 0, startPos = 0, lastX = 0, lastT = 0;

      function wrap(v) { return setWidth ? ((v % setWidth) + setWidth) % setWidth : v; }
      function draw() { track.style.transform = "translate3d(" + (-pos) + "px,0,0)"; }
      /* re-check every ~150px of travel rather than every frame; warming is
         cheap but not free, and 150px is far less than one photo */
      function maybeWarm() {
        /* Not gated on the observer having fired. Anything that moves the band
           is proof it is on screen, and gating on the observer meant that if it
           never fired — a tab loaded in the background, an old browser — no
           amount of dragging would ever warm anything. */
        if (lastWarm === null) { warm(); return; }
        var d = Math.abs(pos - lastWarm);
        if (d > 150 && d < setWidth - 150) warm();
      }

      function frame(t) {
        requestAnimationFrame(frame);
        if (!last) { last = t; return; }
        var dt = (t - last) / 1000;
        last = t;
        if (dt > 0.25) return;           /* back from a background tab: do not lurch */
        if (dragging || !setWidth) return;

        if (Math.abs(vel) > 1) {         /* momentum from a throw */
          pos = wrap(pos + vel * dt);
          vel *= Math.pow(0.002, dt);    /* ~decays to nothing in about a second */
          draw(); maybeWarm();
          return;
        }
        vel = 0;
        if (auto && !paused && !document.hidden) {
          pos = wrap(pos + pxPerSec * dt);
          draw(); maybeWarm();
        }
      }
      requestAnimationFrame(frame);

      rail.addEventListener("pointerdown", function (e) {
        if (e.button != null && e.button !== 0) return;
        dragging = true; vel = 0;
        startX = lastX = e.clientX; startPos = pos; lastT = performance.now();
        rail.classList.add("pt-grabbing");
        warm();                          /* a throw can outrun the 150px check */
        /* Capture last, and never let it break the drag. setPointerCapture
           throws for a pointer the browser does not consider active, and
           anything after it in this handler would then never run — which is
           how a failed capture silently took the warming with it. */
        try { rail.setPointerCapture(e.pointerId); } catch (err) {}
      });
      rail.addEventListener("pointermove", function (e) {
        if (!dragging) return;
        pos = wrap(startPos - (e.clientX - startX));
        draw();
        /* AFTER draw, never before: warm() measures the tiles with
           getBoundingClientRect, so warming first reads the previous frame's
           layout and decides the window from where the band used to be. */
        maybeWarm();
        var now = performance.now(), dt = (now - lastT) / 1000;
        if (dt > 0.004) {                /* px/sec, for the throw */
          vel = -(e.clientX - lastX) / dt;
          lastX = e.clientX; lastT = now;
        }
      });
      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        rail.classList.remove("pt-grabbing");
        try {
          if (e && e.pointerId != null && rail.hasPointerCapture(e.pointerId)) {
            rail.releasePointerCapture(e.pointerId);
          }
        } catch (err) {}
        if (performance.now() - lastT > 120) vel = 0;   /* held still before letting go */
        vel = Math.max(-4000, Math.min(4000, vel));
      }
      ["pointerup", "pointercancel", "pointerleave"].forEach(function (ev) {
        rail.addEventListener(ev, endDrag);
      });

      /* trackpad sideways swipe, without stealing vertical page scroll */
      rail.addEventListener("wheel", function (e) {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
        e.preventDefault();
        vel = 0;
        pos = wrap(pos + e.deltaX);
        draw();
      }, { passive: false });

      /* keyboard: the rail is focusable, so it has to be operable */
      rail.addEventListener("keydown", function (e) {
        var step = originals[0].getBoundingClientRect().width + 10;
        if (e.key === "ArrowRight") { pos = wrap(pos + step); draw(); e.preventDefault(); }
        if (e.key === "ArrowLeft")  { pos = wrap(pos - step); draw(); e.preventDefault(); }
      });

      var hold = function () { paused = true; };
      var release = function () { paused = false; };
      ["pointerenter", "focusin"].forEach(function (e) { rail.addEventListener(e, hold, { passive: true }); });
      ["pointerleave", "focusout"].forEach(function (e) { rail.addEventListener(e, release, { passive: true }); });

      draw();
    });
  }

  /* One coloured sheen across the phone-matcher button the first time it comes
     into view, then it settles into its resting fill and is never animated
     again. The element is removed when the sweep ends so nothing is left
     compositing, and a shopper who scrolls past and back does not retrigger
     it - a button that shimmers repeatedly reads as a loading state, not an
     invitation. */
  var SWEEP_GAP = 5000;      /* quiet time between passes */
  var SWEEP_LEAD = 900;      /* settle before the first pass after scrolling in */

  function initMatchSweep() {
    var btn = document.querySelector(".pt-scope .pt-matchbtn");
    if (!btn || reduced || btn.__ptSweep || !window.IntersectionObserver) return;
    if (S.match) return;                     /* already matched: nothing to invite */
    var st = btn.__ptSweep = { inView: false, timer: 0, stopped: false, first: true };

    function clear() {
      clearTimeout(st.timer);
      st.timer = 0;                          /* so the state reads truthfully */
      var el = btn.querySelector(".pt-sweep");
      if (el) el.remove();
    }
    st.stop = function () { st.stopped = true; clear(); };

    function schedule(delay) {
      clearTimeout(st.timer);
      if (st.stopped || !st.inView) return;
      st.timer = setTimeout(pass, delay);
    }
    function pass() {
      /* A Theme Editor re-render replaces the button; the old one's timer would
         otherwise keep firing against a node nobody can see. */
      if (st.stopped || !st.inView || !btn.isConnected) { st.stopped = true; return; }
      var old = btn.querySelector(".pt-sweep"); if (old) old.remove();
      var sh = document.createElement("span");
      sh.className = "pt-sweep";
      var ended = false;
      var finish = function () {
        if (ended) return;
        ended = true;
        if (sh.parentNode) sh.remove();
        schedule(SWEEP_GAP);
      };
      sh.addEventListener("animationend", finish);
      setTimeout(finish, 6000);              /* the pass never ran: paused tab */
      btn.appendChild(sh);
    }

    /* Only while the button is actually on screen. Off-screen passes are
       invisible work, and coming back to a button mid-shimmer looks like it
       is loading rather than waiting to be pressed. */
    st.setInView = function (v) {
      st.inView = v;
      if (st.stopped) return;
      if (v) { schedule(st.first ? SWEEP_LEAD : SWEEP_GAP); st.first = false; }
      else clear();
    };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { st.setInView(en.isIntersecting); });
    }, { threshold: 0.55 });
    io.observe(btn);
    st.stop = function () { st.stopped = true; clear(); io.disconnect(); };

    /* The invitation has done its job the moment it is taken up. */
    btn.addEventListener("click", function () { st.stop(); });
  }

  /* Called when a phone is matched, from wherever the match came from — the
     sheet, or a restored selection. The matched chip replaces the prompt, so
     the button must stop asking for attention. */
  function stopMatchSweep() {
    var btn = document.querySelector(".pt-scope .pt-matchbtn");
    if (btn && btn.__ptSweep && btn.__ptSweep.stop) btn.__ptSweep.stop();
  }

  /* Theme-editor-only sanity check. The tier percentages now live on the
     product, so a page can silently lose every savings figure if someone
     clears a metafield or renames a group. Shoppers must never see a warning
     — the page just goes quiet, matching what the function charges — but the
     person editing should not have to wonder why the numbers vanished. */
  function warnIfUnconfigured() {
    if (!window.Shopify || !Shopify.designMode || !D) return;
    var msgs = [];
    var anyTier = (D.tiers || []).some(function (t) { return Number(t.pct) > 0; });
    if (!anyTier) {
      msgs.push('No multi-buy tiers on this product. Fill "Multi-buy \u00b7 Tier quantities" and "Tier % off" in the product metafields — same number of entries in each, paired by position. Until then the quantity buttons show no savings.');
    }
    if (!D.cfgGroup) {
      msgs.push('This product has no "Multi-buy group". The discount function needs it to count units, so checkout will not apply a tier.');
    }
    if (D.remote && D.cfgPairGroup && D.cfgGroup &&
        D.cfgPairGroup.split(',').map(function (x) { return x.trim(); }).indexOf(D.cfgGroup) === -1) {
      msgs.push('The add-on attaches to [' + D.cfgPairGroup + '] but this product is in "' + D.cfgGroup + '". Add this group to the add-on, or the bundle discount will not apply.');
    }
    if (D.tierLenMismatch) {
      msgs.push('"Tier quantities" and "Tier % off" have different numbers of entries. They pair by position, so the extras are ignored.');
    }
    if (D.remote && !Number(D.pairPct)) {
      msgs.push('The remote has no "Accessory: % off when paired", so the bundle shows no saving.');
    }
    if (msgs.length && window.console) {
      console.warn('[Pocket Tripod] Multi-buy configuration:\n• ' + msgs.join('\n• '));
    }
  }

  /* Pin the gallery column only when the whole of it fits on screen beneath the
     header. This replaced a hardcoded `min-height:790px` media query, which was
     the column's height plus its offset on the day it was written and carried
     1px of headroom — two more pixels of gallery and the gate would still have
     said "stick" while the bottom of the column became unreachable. Nothing can
     scroll a pinned element's overflow into view, so getting this wrong strands
     content rather than merely looking off.

     Measured rather than assumed, because the offset depends on whether the
     merchant has the theme's sticky header switched on, and the column's height
     depends on how many thumbnails the product has. */
  function fitLeftSticky() {
    var left = document.querySelector(".pt-scope .pt-left");
    if (!left) return;
    var root = document.documentElement;
    if (!window.matchMedia("(min-width:900px)").matches) {
      root.classList.remove("pt-leftstick");
      return;
    }
    /* park below the theme's header when it is sticky, otherwise just inset */
    var off = 20;
    if (document.body.classList.contains("header-is-sticky")) {
      var hdr = document.querySelector("main-header, header .site-header, header");
      if (hdr) off = Math.round(hdr.getBoundingClientRect().height) + 20;
    }
    left.style.setProperty("--pt-lefttop", off + "px");

    /* A laptop viewport is often a few dozen pixels short of the column, and
       losing the pin over that is a poor trade for an image nobody asked to be
       exactly that tall. Trim the gallery to whatever is left before deciding.
       Measured with the cap already off, so the check reads the natural height
       and the trim never ratchets smaller on repeated calls. */
    var gal = left.querySelector(".pt-gal");
    var GAL_MIN = 380;
    root.classList.remove("pt-galcap");
    if (gal) {
      var chrome = left.offsetHeight - gal.offsetHeight;   /* thumbs + margins */
      var room = window.innerHeight - off - 16 - chrome;
      if (room >= GAL_MIN && room < gal.offsetHeight) {
        gal.style.setProperty("--pt-galh", Math.floor(room) + "px");
        root.classList.add("pt-galcap");
      } else {
        gal.style.removeProperty("--pt-galh");
      }
    }

    /* offsetHeight, not getBoundingClientRect: the column is unaffected by any
       transform, and offsetHeight is not fractional, so the comparison cannot
       flap between sticky and static on a sub-pixel rounding difference */
    root.classList.toggle("pt-leftstick", left.offsetHeight + off + 16 <= window.innerHeight);
  }
  var leftStickT;
  function queueLeftStick() {
    clearTimeout(leftStickT);
    leftStickT = setTimeout(fitLeftSticky, 120);
  }
  window.addEventListener("resize", queueLeftStick);
  /* belt for Safari: observe the column itself, so the gallery height cap
     (--pt-galh) is re-derived even when window-resize events misfire */
  (function () {
    var leftEl = document.querySelector(".pt-scope .pt-left");
    if (leftEl && "ResizeObserver" in window) new ResizeObserver(queueLeftStick).observe(leftEl);
  })();

  /* Attach a deferred video's sources to whichever frame is actually showing.
     Only used when the section carries BOTH a landscape and a portrait cut:
     hiding one with CSS does not stop it downloading — measured, a display:none
     video with preload="none" and autoplay still pulled the whole file, because
     autoplay overrides preload. With one file the markup carries its own
     <source> tags and none of this runs. */
  function hydrateSoloVideo() {
    var phone = window.matchMedia("(max-width:749px)").matches;
    document.querySelectorAll(".pt-scope .pt-solovid video[data-pt-vsrc]").forEach(function (v) {
      if (v.__ptHydrated) return;
      var frame = v.parentElement;
      var wantsThis = frame && frame.classList.contains("pt-solovid--mob") ? phone : !phone;
      if (!wantsThis) return;
      var list;
      try { list = JSON.parse(v.getAttribute("data-pt-vsrc")); } catch (err) { return; }
      if (!list || !list.length) return;
      list.forEach(function (s) {
        var el = document.createElement("source");
        el.src = s.src;
        if (s.type) el.type = s.type;
        v.appendChild(el);
      });
      v.__ptHydrated = true;
      v.load();
    });
  }
  var soloT;
  window.addEventListener("resize", function () {
    clearTimeout(soloT);
    soloT = setTimeout(hydrateSoloVideo, 200);
  });

  /* Keep the sticky bar above the browser's own bottom chrome.

     position:fixed anchors to the LAYOUT viewport, which on iOS extends behind
     the collapsing toolbar — and in the Instagram browser behind a toolbar that
     never collapses at all. The bar then sits partly or almost entirely off
     screen, and appears to drift as the toolbar grows and shrinks with scroll.
     env(safe-area-inset-bottom) does not cover this: it reports the home
     indicator, not browser chrome, and is 0 in most in-app browsers.

     visualViewport is the only thing that knows where the visible bottom
     actually is. The gap between the two viewports becomes a custom property
     the bar adds to its offset. */
  function fitStickyBar() {
    var vv = window.visualViewport;
    if (!vv) return;                                   /* old browsers keep the CSS default */
    /* documentElement.clientHeight, not innerHeight. position:fixed resolves
       against the LAYOUT viewport, and that is what clientHeight reports. On
       iOS innerHeight already tracks the VISUAL viewport, so the old
       subtraction compared a value with itself and answered 0 — which is why
       the bar's bottom corners stayed cropped after the first attempt. */
    var bar = document.querySelector(".pt-scope .pt-satc");
    if (!bar || !bar.offsetHeight) return;
    /* Place it by its TOP edge, measured from the visual viewport's own bottom.
       Two attempts at a `bottom` offset failed because `bottom` resolves
       against the layout viewport, and no arithmetic on it can find a toolbar
       the layout viewport does not know about. This asks the only object that
       does know — visualViewport — where the visible bottom is, and puts the
       bar above it. */
    /* match what the CSS used before JS took over the placement */
    var inset = window.innerWidth >= 900 ? 16 : 14;
    /* Where the bar WOULD sit from its CSS `bottom`, versus where the visible
       bottom actually is. The difference is fed back as a transform rather than
       written to `top`: same position, but it stays off the layout path. */
    /* Worked out rather than measured. Reading the rect back gave a position
       that already carried the enter/leave offset — the bar is translated fully
       off-screen until it is shown — so the correction was computed against a
       hidden element and left it below the fold. The CSS `bottom` resolves to
       px on its own, and that is all this needs. */
    var layoutH = document.documentElement.clientHeight || window.innerHeight;
    var barTop = vv.offsetTop + vv.height - bar.offsetHeight - inset;
    bar.style.top = Math.round(barTop) + "px";
    bar.style.bottom = "auto";
    /* The toast sat at a fixed 96px from the layout viewport bottom, which put
       it straight over the Add to cart button. Stack it above the bar, measured
       from the same visible bottom, so the confirmation never covers the thing
       it is confirming. */
    var toast = document.getElementById("pt-toast");
    if (toast) {
      var th = toast.offsetHeight || 40;
      /* Clear the sticky bar AND the inline Add to cart. Sitting just above the
         bar was not enough: after a match the page lands with the in-page CTA
         low on the screen, and the toast came down on top of it — the same
         collision as before, with a different button. Whichever of the two is
         higher wins, plus room to read as a separate thing rather than a label
         stuck to the button. */
      /* The confirmation belongs UNDER the Add to cart button (owner
         2026-08-19: the above-the-colour-row spot read as mid-page). After a
         match the page lands with the button and the shipping line at the
         bottom of the view, so just below the button is both visible and out
         of the way. Fall back to just above the sticky bar when the button
         is off-screen (e.g. adding from the bar itself). */
      var atc = document.getElementById("pt-iatc");
      var ar = atc ? atc.getBoundingClientRect() : null;
      if (ar && ar.height && ar.top >= 0 && ar.bottom + th + 34 <= barTop) {
        toast.style.top = Math.round(ar.bottom + 12) + "px";
        /* centred on the BUTTON, not the viewport — page-centred it straddled
           the gallery on desktop and read as detached from what it confirms */
        toast.style.left = Math.round(ar.left + ar.width / 2) + "px";
      } else {
        toast.style.top = Math.round(barTop - th - 22) + "px";
        toast.style.left = "50%";
      }
      toast.style.bottom = "auto";
    }
  }
  if (window.visualViewport) {
    /* visualViewport fires in steps while the browser's own toolbar slides, so
       reading it directly moved the bar in jumps against a chrome that was
       animating smoothly — worse when scrolling up and down, because each
       direction change produced another jump. Run it on a frame instead, and
       coalesce: several events inside one frame do one move. The easing that
       carries it between positions is on the element, in CSS. */
    var vvTick = 0;
    var onVV = function () {
      if (vvTick) return;
      vvTick = requestAnimationFrame(function () { vvTick = 0; fitStickyBar(); });
    };
    window.visualViewport.addEventListener("resize", onVV);
    window.visualViewport.addEventListener("scroll", onVV);
    window.addEventListener("scroll", onVV, { passive: true });
    window.addEventListener("orientationchange", fitStickyBar);
    fitStickyBar();
  }
  document.addEventListener("shopify:section:load", hydrateSoloVideo);
  hydrateSoloVideo();

  function initBuyDom() {
    bindTrack();
    warnIfUnconfigured();
    applySelState();   /* before anything renders, so a re-render can't show a stale choice */
    initMatchSweep();
    initProofRails();
    renderDelDate();
    renderTrack(); drawSwatches(); drawQty(); renderUnits(); sync();
    plInitTimer();
    /* after the gallery has its thumbnails, so the height being measured is
       the real one rather than an empty column */
    fitLeftSticky();
    /* preload BOTH fit hero photos: the first fit toggle must swap from
       cache, not show a blank slide while the other photo downloads */
    if (fitPhotoMode()) {
      [D.fitPhotoStd, D.fitPhotoSlim].forEach(function (p) {
        var im = new Image(); im.decoding = "async"; im.src = p.src;
      });
    }
  }
  initBuyDom();

  /* idle prefetch (owner 2026-08-20): warm every colour's variant image and
     box render once the page has settled, so the first click on any swatch
     swaps instantly instead of paying the CDN's cold-rendition cost. The
     current fit's images queue first; two downloads in flight at a time so
     it never competes hard with anything the shopper actually asked for.
     Skipped on data-saver and 2G connections. */
  function prefetchVariantImages() {
    try {
      var con = navigator.connection;
      if (con && (con.saveData || /(^|-)2g$/.test(con.effectiveType || ""))) return;
    } catch (e) { /* no connection API: prefetch anyway */ }
    var seen = {}, q = [];
    var add = function (src) { if (src && !seen[src]) { seen[src] = 1; q.push(src); } };
    (D.variants || []).forEach(function (v) { if (v.fit === S.fit) add(v.image); });
    (D.variants || []).forEach(function (v) { add(v.image); });
    (D.colors || []).forEach(function (c) { add(c.boxStd); add(c.boxSlim); });
    if (D.remote) add(D.remote.boxImage);
    var i = 0;
    var next = function () {
      if (i >= q.length) return;
      var im = new Image();
      im.decoding = "async";
      im.onload = im.onerror = next;
      im.src = q[i++];
    };
    next(); next();   /* two lanes */
  }
  (function () {
    var idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 250); };
    var arm = function () { setTimeout(function () { idle(prefetchVariantImages); }, 1200); };
    if (document.readyState === "complete") arm();
    else window.addEventListener("load", arm);
  })();

  /* Theme Editor: a setting tweak re-renders the buy box's DOM with empty
     containers and a fresh #pt-data blob; re-read the blob and repopulate
     (storefront never fires this event). Freshly ADDING a buy box to a page
     that loaded without one still needs a preview refresh. */
  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target;
    if (!root || !root.querySelector) return;
    var el = root.querySelector("#pt-data");
    if (!el) return;
    try { D = JSON.parse(el.textContent); } catch (err) { return; }
    buildVBY();
    plSetup(); /* fresh blob = fresh full prices; re-apply the pre-launch transform */
    saleSetup(); /* and the sale transform, or a market switch repaints at full price */
    gpos = 0;
    var avail = colorsFor(S.fit);
    if (!avail.some(function (c) { return c.name === S.color; })) S.color = (avail[0] || { name: "" }).name;
    initBuyDom();
  });
})();
